/* eslint-disable no-useless-escape */
import { queryPZToken } from '@api/index';
import { message, Modal } from 'antd'
import { multipartUpload, detectImageBase } from "@api/sk";
import { teamRoute, hwObsConfigInfo, unsavedTip, bujueDecryptKey, maxUploadLimit, uploadImageWidthAndHeightLimit, uploadTip, cloudDiskFileTypeIdentification, aliOssConfigInfo, roleValueList, ym_url } from "./enum";
import { SUPPORTED_LANGUAGES } from "./langConfig";
import { getTranslationPack } from "./remote_lang_pack";
import axios from "axios";
import ObsClient from 'esdk-obs-browserjs';
import OSS from 'ali-oss';
import { workdisplayinfoExistExtraInfo, workdisplayinfoUploadingIsCompleted, uploadImgInQueue, uploadVideoInQueue } from '@api/works';
import { uploadImgNewInQueue, getAssumeRoleByUser } from '@api/product';
import { queryByTeamIdAndUserId } from '@api/team';
import { copyOriginToCloud } from '@api/cloud_disk';
import CryptoJs from 'crypto-js';
import moment from "moment";
import { FFmpeg } from '@ffmpeg/ffmpeg';
import { getkey, getCookie,  getQueryVariable, isIPad,  identifyDevicePlatform, isWeChat, getOperatingSystem, isVideo, replaceUrlPort, useCdn, useCdnNew, isHadByTime,
getZipImg,  isHadSize,  imgIsEnableYs, toQualityImg } from "@util/utils_cover";

// 语言包 locale → 语言码（未知语言沿用原来的英文兜底）
const LOCALE_TO_CODE = SUPPORTED_LANGUAGES.reduce((acc, item) => {
  acc[item.locale] = item.code;
  return acc;
}, {});

// 虚机多语言的方法（取值走 remote_lang_pack 的合并结果：远程优先、本地兜底）
const useTranslation = () => {
  return {
    t:(str) =>{
      const curlang = sessionStorage.getItem('lang')||window.lang
      return getTranslationPack(LOCALE_TO_CODE[curlang] || "en")[str] || str
    } 
  }
}




export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = "expires=" + d.toGMTString();
  const href = window.location.href;
  let str = '.bujue.art';
  if (href.indexOf('.panzitech.com') >= 0) {
    str = '.panzitech.com';
  }
  if (href.indexOf('.ngtest.guyubao.com') >= 0) {
    str = '.ngtest.guyubao.com'
  }

  if (href.indexOf('.ngrok.xiaomiqiu123.top') >= 0) {
    str = '.ngrok.xiaomiqiu123.top'
  }
  //给尊贵的我加个vip3d 权限
  if (href.indexOf('vip3.xiaomiqiu123.top') >= 0) {
    str = '.xiaomiqiu123.top'
  }
  if (href.indexOf('ngrok.xiaomiqiu123.top') >= 0) {
    str = '.ngrok.xiaomiqiu123.top'
  }
  if (href.indexOf('.ngtest.guyubao.com') >= 0) {
    str = '.ngtest.guyubao.com'
  }

  // 局域网 IP / localhost 访问时，浏览器不允许把 cookie 写到 .bujue.art 等父域下（Set-Cookie 会被静默丢弃，
  // 导致 mtoken 一直读不到）。这种场景退化成 host-only cookie（不带 domain），只在当前 host 下生效。
  const hostname = window.location.hostname;
  const isLanIpOrLocalhost = /^(\d{1,3}\.){3}\d{1,3}$/.test(hostname) || hostname === 'localhost';
  const domainAttr = isLanIpOrLocalhost ? '' : `;domain=${str}`;

  document.cookie = `${cname} = ${cvalue} ;${expires} ${domainAttr}; path=/`;
}

// 删除cookie
export function clearCookie(name) {
  setCookie(name, "", -1);
}



/**
 * 防抖函数
 * @param  callback
 */
export function debounce(callback, delay) {
  let timer = null;

  return function () {
    if (timer !== null) {
      clearTimeout(timer);
    }
    const args = arguments;
    timer = setTimeout(() => {
      callback.apply(this, args);
    }, delay);
  };
}

//手机号脱敏
export function desensiPhone(phone) {
  if (phone) {
    return phone.replace(/(\d{3})\d*(\d{4})/, "$1****$2");
  }
  return "";
}

//邮箱脱敏
export function desensiEmail(email) {
  if (email) {
    return email.replace(/(.{0,2}).*(.{1})@(.*)/, "$1***$2@$3");
  }
  return "";
}

export function checkImgExists(url) {
  return new Promise(function (resolve, reject) {
    var ImgObj = new Image();
    ImgObj.src = url;
    ImgObj.onload = function () {
      resolve(true);
    };
    ImgObj.onerror = function () {
      reject(false);
    };
  });
}

export function isImgExists(url) {
  return checkImgExists(url)
    .then(() => {
      return true;
    })
    .catch(() => {
      return false;
    });
}

// 图片缩略图处理
export function imghandle(url, zip = true) {
  // let newUrl = '';
  if (typeof url !== 'string') return ''
  if (url && isVideo(url)) {
    return videoImg(url);
  }

  if (url) {
    return imghandle_New(url, zip);
    // if (url?.indexOf(':443') > 0) {
    //   newUrl = url?.replace(
    //     "https://oss-panzi-app-test.panzitech.com/",
    //     "https://app-test.zjhzoyad.com/"
    //   );
    // } else {
    //   newUrl = url.replace(
    //     "https://oss-panzi-app-test.panzitech.com/",
    //     "https://app-test.zjhzoyad.com/"
    //   );
    // }
    // let zipUrl = zip
    //   ? newUrl.replace(
    //     "https://app-test.zjhzoyad.com/",
    //     "https://app-test.zjhzoyad.com/zip-"
    //   )
    //   : newUrl.replace(
    //     "https://app-test.zjhzoyad.com/",
    //     "https://app-test.zjhzoyad.com/crop-"
    //   );
    // return zipUrl;
  }
}
// 图片缩略图处理 暂时用原图地址
export function imghandle_New(url, zip = true) {
  let newUrl = url;
  if (url?.indexOf(':443') > 0) {
    newUrl = replaceUrlPort(url);
  }
  let zipUrl = zip ? replaceUrl(newUrl, 'zip-') : replaceUrl(newUrl, 'crop-');
  return zipUrl;
}


/**
       * 
       * @param {*} windowWidth 屏幕宽度 
       * @param {*} windowHeight 屏幕高度
       * @param {*} imageWidth    图片真实宽度
       * @param {*} imageHeight   图片真实高度
       */
export function comImageWidthHeight(windowWidth, windowHeight, imageWidth, imageHeight) {
  const minHeightCoefficient = 0.2,
    maxHeightCoefficient = 0.7;
  //正常手机是375 812 * maxHeightCoefficient  0.65

  const imageProportion = imageWidth / imageHeight, //图片比列
    windowProportion = windowWidth / (windowHeight * maxHeightCoefficient); //手机屏幕比列
  let height = 0;
  let truthHeight = (windowWidth / imageWidth) * imageHeight; //真实的图片高度 在撑满的情况
  //设图片比列是1比1  那么图片就得是
  if (imageProportion > windowProportion) {
    //图片是横着的情况 希望减少上下留白
    height = Math.max(truthHeight, windowHeight * minHeightCoefficient)
  } else {
    //图片是竖着的 希望减少左右留白
    height = windowHeight * maxHeightCoefficient
  }
  return height;

}
// 方法一：使用Image对象异步获取（推荐）
export function getImageDimensions(url) {
  return new Promise((resolve, reject) => {
    const img = new Image()

    // 处理跨域请求
    img.crossOrigin = 'Anonymous'

    img.onload = () => {
      resolve({
        width: img.naturalWidth,  // 获取原始宽度
        height: img.naturalHeight // 获取原始高度
      })
    }

    img.onerror = (err) => reject(err)

    // 开始加载
    img.src = url

    // 如果图片已缓存
    if (img.complete) {
      img.onload()
    }
  })
}

// 使用示例


export function getZipMarkerImg(url) {
  if (!url) return '';
  if (isVideo(url)) return url;
  const img = useCdn(url);
  if (!img) return '';
  return replaceUrl(img, 'markv2-zip-');
}

function replaceUrl(url, str) {
  // let newUrl = ''
  // if (url.indexOf('https://oss-panzi-app-test.panzitech.com') >= 0) {
  //   newUrl = url.replace(
  //     "https://oss-panzi-app-test.panzitech.com/",
  //     `https://oss-panzi-app-test.panzitech.com/${str}`
  //   )
  // } else {
  //   newUrl = url.replace(
  //     "https://oss-panzi-app-test.panzitech.com/",
  //     `https://oss-panzi-app-test.panzitech.com/${str}`
  //   )
  // }
  // return newUrl;
  return url.replace(/\/(?!.*\/)/g, `/${str}`)

}
export function getMarkImg(url) {
  if (isVideo(url)) return url;
  const img = useCdn(url);
  // if (isHadByTime(img, 1676913067251)) {
  //   // 暂时用原图地址
  //   return img.replace(
  //     "https://oss-panzi-app-test.panzitech.com/",
  //     "https://oss-panzi-app-test.panzitech.com/mark-"
  //   )
  //   // return img.replace(
  //   //   "https://app-test.zjhzoyad.com/",
  //   //   "https://app-test.zjhzoyad.com/mark-"
  //   // );
  // }
  return img;
}
export const stringToBase64 = (str) => {
  const encoder = new TextEncoder();
  const uint8Array = encoder.encode(str);
  // 使用btoa函数将Uint8Array转换为Base64字符串
  // 但由于btoa接受的是二进制字符串（每个字符代表一个字节），我们需要先将Uint8Array转换为这样的字符串
  const binaryString = String.fromCharCode.apply(null, uint8Array);
  const base64String = window.btoa(binaryString);
  const urlSafeBase64 = base64String
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
  return urlSafeBase64;
  // return base64String;
}
export const getlogoBase64 = (url) => {
  let str = url;
  str = str.replaceAll("https://oss-panzi-app-test.panzitech.com/", "");
  return stringToBase64(str);
};
export const getFillImg = (params,logo,img,cropInfo) => {
  let pady = 60;
  let padx = 80;

  let bx = 26;
  let by = 16;
  let arr = [];
  for (const key in params) {
    if (key == "g"||key == "t"||key=='fill') {
      arr.push(`${key}_${params[key]}`);
    }
  }
  let {width,height} = getPxByPath(img)
  // 裁剪图宽高
  if(cropInfo?.width&&cropInfo.height){
    width = (cropInfo.width/100)*width;
    height = (cropInfo.height/100)*height;
  }
  const screenPix = window.screen.width/window.screen.height;
  const imgPix = width/height;
  // console.log(imgPix,screenPix)
  let p = params.p
  const devicePlatform = localStorage.getItem('devicePlatform')
  // pc端canvas画的要取展示图片宽高计算比列
  if(devicePlatform!='phone'){
    if(imgPix>screenPix){
      if(width>window.screen.width){
        width = window.screen.width
        height = width/imgPix
      }
      padx = Math.ceil((width/616)*padx)
      pady =  Math.ceil((height/553)*pady)
      bx = Math.ceil((width/616)*bx)
      by =  Math.ceil((height/553)*by)
      p = (width/616)*params.p
      if(p*params.dragInfo.height/100>height){
        p = (height/553)*params.p
      }
    }else{
      if(height>window.screen.height){
        height = window.screen.height
        width = height*imgPix
      }
      padx = Math.ceil((width/616)*padx)
      pady =  Math.ceil((height/553)*pady)
      bx = Math.ceil((width/616)*bx)
      by =  Math.ceil((height/553)*by)
      p = (height/553)*params.p
      if(p*params.dragInfo.width/100>width){
        p = (width/616)*params.p
      }
    }
  }else{// 手机端按图片原图宽高计算比列
    // 最长边不超过20000
    if(height>2000){
      height = 2000;
      width = height*imgPix
    }
    if(width>2000){
      width = 2000;
      height = width/imgPix
    }
    padx = Math.ceil((width/616)*padx)
    pady =  Math.ceil((height/553)*pady)
    bx = Math.ceil((width/616)*bx)
    by =  Math.ceil((height/553)*by)
    p = (height/553)*params.p
    if(height>width){
      p = (width/616)*params.p
    }
   
  }
  
 console.log(p)
  if (params.fill == 0) {
    arr.push(`x_${bx}`);
    arr.push(`y_${by}`);
  } else {
    arr.push(`pady_${pady}`);
    arr.push(`padx_${padx}`);
  }
 console.log(img,cropInfo,params)
  

  if (arr.length > 0) {
    let pstr = `/resize,p_${Math.ceil(p)}`;
    let newLogo = logo.replace("x-image-process", "x-oss-process");
    if (logo.indexOf("?x-image-process") >= 0) {
      let arr = logo.split("?");
      newLogo = arr[0];
    }
    if (newLogo.indexOf("x-oss-process=image") >= 0) {
      pstr = "," + pstr;
    } else {
      pstr = "?x-oss-process=image" + pstr;
    }
    let str = `?x-oss-process=image/auto-orient,1/watermark,image_${getlogoBase64(
      newLogo + pstr
    )},${arr.join(",")}`;
    console.log(str)
    return str;
  }
};
export function getMarkImg2(url, mark,cropInfo,zipstr) {
  let img = url;
  if (isVideo(img) || isGif(img)) return img;
  if (img.indexOf('https://app-test.obs.cn-east-2.myhuaweicloud.com') >= 0) img = img.replace("https://app-test.obs.cn-east-2.myhuaweicloud.com", "https://oss-panzi-app-test.panzitech.com")
  if (url.indexOf('crop-') >= 0 && mark === true) return url;
  if (mark !== true) {
    // 不同域名直接返回原图
    // if(url.indexOf('https://oss-panzicdn-test.panzitech.com')>=0) return url;
    // 是否超过25mb
    if (imgIsMax(img, 20)) {
      img = replaceUrl(img, zipstr||'zip-');
    }
    if(mark?.logoMark){
     const roleMark =  getFillImg(mark,mark?.logoMark,url,cropInfo)
     return img + roleMark;
    }
    return img + mark;
  }
  if (url.indexOf(':443') >= 0) {
    img = replaceUrlPort(url);
  }
  if (url.indexOf('app-test.obs.cn-east-2.myhuaweicloud.com') >= 0) {
    return replaceUrl(img, 'markv2-');
  }
  if (url.indexOf('oss-panzi-app-test.panzitech.com') >= 0) {
    return replaceUrl(img, 'markv2-');
  }
  return url;
}
// 获取经纬度
export function getLocation() {
  return new Promise(function (resolve) {
    // eslint-disable-next-line no-undef
    var myCity = new BMap.LocalCity();
    myCity.get((res) => {
      resolve(res);
    });
  });
}

// 获取地理位置信息
export function getLocationBaiduIp(position) {
  return new Promise(function (resolve) {
    var BMapGL = window.BMap;
    var point = new BMapGL.Point(position?.lng, position?.lat);
    var myGeo = new BMapGL.Geocoder();
    // 根据坐标得到地址描述
    myGeo.getLocation(point, function (res) {
      resolve(res);
    });
  });
}

export function currentUser() {

  if (window.__user__ !== null && window.__user__ !== undefined) {
    return window.__user__;
  }
  return JSON.parse(localStorage.getItem("user"));
}



export const getClientInfo = (item) => {
  switch (item.clientType) {
    case 1:
      return {
        name: item?.client?.name,
        logo: item?.client?.avator,
      };
    case 2:
      return {
        name: item?.client?.name,
        logo: item?.client?.name,
      };
    case 3:
      return {
        name: item?.client?.rName,
        logo: item?.client?.rLogo,
      };
  }
}


export function latelySearch() {

  if (!localStorage.getItem("lately_search")) {
    return [];
  }
  return JSON.parse(localStorage.getItem("lately_search"));
}

export function getElementCss(e, name) {
  let st = window.getComputedStyle(e, null);
  return st.getPropertyValue(name);
}

// 获取transform属性值
export function getTransformPara(elem) {
  // var elem = document.getElementById(id);
  let tr = getElementCss(elem, "-webkit-transform");
  if (tr != "none") {
    let values = tr.split("(")[1].split(")")[0].split(",");
    let a = values[0];
    let b = values[1];
    let c = values[2];
    let d = values[3];
    let e = values[4];
    let f = values[5];
    let scale1 = Math.sqrt(a * a + b * b);
    let scale2 = Math.sqrt(c * c + d * d);
    let angle = Math.atan2(b, a) * (180.0 / Math.PI);
    e = parseFloat(e);
    f = parseFloat(f);
    let radian = -Math.PI / 180.0 * angle;
    let lastX = Math.cos(radian) * e - Math.sin(radian) * f;
    let LastY = Math.sin(radian) * e + Math.cos(radian) * f;
    return {
      ScaleX: scale1,
      ScaleY: scale2,
      Angle: angle,
      MovX: lastX,
      MovY: LastY,
    };
  }
  else {
    return {
      ScaleX: 1,
      ScaleY: 1,
      Angle: 0,
      MovX: 0,
      MovY: 0,
    };
  }
}

// 处理视频第一帧图片
/**
 * frame 字段的容错解析。
 * 后端下发的是**字符串化的 map**（key = 视频地址、value = 首帧图，多为 .jpeg）：
 *   "{\"https://xxx/xx.mp4\":\"https://xxx/xx.jpeg\"}"
 * 也遇到过程序里已经是对象的情况，这里统一成对象；解析失败返回 null（不让它把渲染搞崩）。
 */
function parseFrameMap(frameObj) {
  if (!frameObj) return null;
  try {
    return typeof frameObj === "string" ? JSON.parse(frameObj) : frameObj;
  } catch (e) {
    return null;
  }
}

/**
 * 从 frame map 里取**首帧图（value，不是 key）**。
 *
 * key 是后端存的那个视频地址，和页面里拿到的封面地址**常常不是同一个字符串**
 * （压缩前后域名/前缀不同、编码差异等），直接 frame[url] 很容易 miss。
 * 所以按三级取：
 *   1. 精确匹配 frame[url]；
 *   2. 按文件名匹配（忽略域名/前缀/参数，文件名做 decodeURIComponent）；
 *   3. 整张 map 只有一条时直接取那一条（一个产品一个视频封面很常见）。
 *
 * @returns {string} 取不到返回 ""
 */
function pickFrameFromMap(url, frameObj) {
  const frame = parseFrameMap(frameObj);
  if (!url || !frame || typeof frame !== "object") return "";
  if (frame[url]) return frame[url];
  const fileName = (u) => {
    let name = String(u || "").split("?")[0].split("/").pop();
    try {
      name = decodeURIComponent(name);
    } catch (e) {
      // 文件名里有单独的 % 之类，保持原样
    }
    return name;
  };
  const target = fileName(url);
  if (target) {
    const hitKey = Object.keys(frame).find((k) => fileName(k) === target);
    if (hitKey && frame[hitKey]) return frame[hitKey];
  }
  const keys = Object.keys(frame);
  if (keys.length === 1 && frame[keys[0]]) return frame[keys[0]];
  return "";
}

export function videoImg(url, frameObj = null) {
  // 先取 frame map 里后端预生成的**首帧图（value）**；
  // 没命中才退回按视频地址派生的 video-images/xxx_first_frame.jpg
  const mapped = pickFrameFromMap(url, frameObj);
  if (mapped) return mapped;
  let videoUrl
  if (isHwObsMedia(url)) {
    if (url.indexOf(':443') >= 0) {
      videoUrl = url.replace(
        'https://app-test.obs.cn-east-2.myhuaweicloud.com:443/',
        'https://oss-panzicdn-test.panzitech.com/video-images/'
      );
    } else {
      videoUrl = url.replace(
        'https://app-test.obs.cn-east-2.myhuaweicloud.com/',
        'https://oss-panzicdn-test.panzitech.com/video-images/'
      );
    }
  } else {
    videoUrl = url.replace(
      'https://oss-panzi-app-test.panzitech.com/',
      'https://oss-panzicdn-test.panzitech.com/video-images/'
    );
  }

  let urlArr = videoUrl?.split('.');
  urlArr[urlArr?.length - 2] = urlArr[urlArr?.length - 2] + '_first_frame';
  urlArr[urlArr?.length - 1] = 'jpg';
  let finalUrl = urlArr.join('.')
  return finalUrl;
}

//节流函数 interval/1000秒内只执行第一次
export function throttle(fn, interval) {
  var timer;
  return function () {
    if (timer) {
      return false;
    } else {
      fn.apply(this, arguments);
    }
    timer = setTimeout(function () {
      clearTimeout(timer);
      timer = null;
    }, interval);
  };
}

export function formatBytes(a, b) {
  // 入参小于 0（如超额时后端返回的负数剩余容量）一律当 0 处理：
  // 负数走 Math.log 会得到 NaN，e[NaN] 又是 undefined，最终渲染成 "NaNundefined"。
  // 用 !(a > 0) 而不是 a <= 0，可顺带兜住 null / undefined / NaN / 非数字字符串。
  if (!(a > 0)) return "0 B";
  let c = 1024,
    d = b || 1,
    e = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    f = Math.floor(Math.log(a) / Math.log(c));
  return parseFloat((a / Math.pow(c, f)).toFixed(d)) + e[f];
}

export default function kelvinToRGB(temp) {
  let out;
  if (!Array.isArray(out)) {
    out = [0, 0, 0]
  }

  temp = temp / 100
  var red, blue, green

  if (temp <= 66) {
    red = 255
  } else {
    red = temp - 60
    red = 329.698727466 * Math.pow(red, -0.1332047592)
    if (red < 0) {
      red = 0
    }
    if (red > 255) {
      red = 255
    }
  }

  if (temp <= 66) {
    green = temp
    green = 99.4708025861 * Math.log(green) - 161.1195681661
    if (green < 0) {
      green = 0
    }
    if (green > 255) {
      green = 255
    }
  } else {
    green = temp - 60
    green = 288.1221695283 * Math.pow(green, -0.0755148492)
    if (green < 0) {
      green = 0
    }
    if (green > 255) {
      green = 255
    }
  }

  if (temp >= 66) {
    blue = 255
  } else {
    if (temp <= 19) {
      blue = 0
    } else {
      blue = temp - 10
      blue = 138.5177312231 * Math.log(blue) - 305.0447927307
      if (blue < 0) {
        blue = 0
      }
      if (blue > 255) {
        blue = 255
      }
    }
  }

  out[0] = Math.floor(red)
  out[1] = Math.floor(green)
  out[2] = Math.floor(blue)
  return out
}
export function getSsOUrl() {
  if (location.origin === "https://bujue.panzitech.com")
    return "https://sso-panbadou.panzitech.com";
  return "https://sso-panbadou-test.panzitech.com";
  // return "http://yjr.panzitech.com:8998";
}

export async function getTokenByPz(url) {
  try {
    const res = await queryPZToken();
    if (res.success) {
      setCookie('mtoken', res.token, 7);
      location.replace(url)
    } else {
      clearCookie("mtoken");
      location.replace('/');
    }
  } catch (error) {
    console.log(error)
  }
}

export function copyUrl(e,msg) {
  //  console.log(e);
  const textarea = document.createElement('textarea');
  textarea.setAttribute('readonly', 'readonly');
  textarea.value = e;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  message.success(msg||"复制成功")
  try {
    document.body.removeChild(textarea);
  } catch (e) {
    console.log(e)
  }

}

export function getBrowserType() {
  const explorer = window.navigator.userAgent;
  // console.log("getBrowserType:" + explorer);
  if (/(micromessenger)/i.test(explorer)) {
    return "微信";
  } else if (/(?:Android)/i.test(explorer)) {
    if (!/(?:Mobile)/.test(explorer)) {
      //安卓平板
      return "AndroidTablet";
    }
  } else if (isIPad()) {
    return "iPad";
  } else if (/(?:webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Tablet)/i.test(explorer)) {
    return "";
  } else if (explorer.indexOf("MSIE") >= 0) {
    return "IE";  //判断是否为IE浏览器
  } else if (explorer.indexOf("EDG") >= 0) {
    return "EDG";  //判断是否为IE浏览器
  } else if (explorer.indexOf("Firefox") >= 0) {
    return "Firefox";  //是否为Firefox浏览器
  } else if (explorer.indexOf("Chrome") >= 0) {
    if (explorer.indexOf("Windows") >= 0) {
      return "WindowsChrome"
    } else if (explorer.indexOf("Mac OS") >= 0) {
      return "Mac OSChrome"
    }
    return "Chrome";  //是否为Chrome浏览器
  } else if (explorer.indexOf("Opera") >= 0) {
    return "Opera";   //是否为Opera浏览器
  } else if (explorer.indexOf("Safari") >= 0) {
    return "Safari";  //是否为Safari浏览器
  } else {
    return "未知的设备";
  }
}

//图片是否超过25mb
export function imgIsMax(url, mbSize = 25) {
  if (!isHadByTime(url, 1699954972150)) return false;
  const size = isHadSize(url);
  if (size) return Math.ceil(size / 1024 / 1024) > mbSize;
  return false;
}


export function toQualityImg_s(url, isZip = false, thumbnail = false) {
  if (!url) return url;
  if (typeof url !== 'string') return '';
  if (url.indexOf('zip-') >= 0) return url;
  if (isZip) {
    if (url?.toLowerCase()?.endsWith('.gif')) {
      return url
    }
    return getZipImg(url);
  }
  if (isVideo(url)) return url;
  if (!isHadByTime(url, 1640966400000)){
    return url
  }
  const img = useCdn(url)
  if (imgIsEnableYs(url)) {
    if (!img || (img?.indexOf('?x-oss-process=image') !== -1)) return img
    return img + (!thumbnail ? `?x-oss-process=image/resize,s_2000` : `?x-oss-process=image/resize,w_300,h_300/quality,q_30`)
  }
  return img
}


export function isSafari() {
  let u = navigator.userAgent
  return (/Safari/.test(u) && !/Chrome/.test(u))
}

export function getRatio() {
  var ratio = 0
  var screen = window.screen;
  var ua = navigator.userAgent.toLocaleLowerCase();
  if (window.devicePixelRatio !== undefined) {
    ratio = window.devicePixelRatio
  } else if (~ua.indexOf('msie')) {
    if (screen.deviceXDPI && screen.logicalXDPI) {
      ratio = screen.deviceXDPI / screen.logicalXDPI
    }
  } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
    ratio = window.outerWidth / window.innerWidth;
  }
  if (ratio) {
    ratio = Math.round(ratio * 100) / 100
  }
  return ratio
}

export const getTime = (dateStr) => {
  const date = new Date(dateStr);
  return date.getTime();
}

// 判断是否有前缀
export const isPrefix = (url = null) => {
  const origin = window.location.origin;
  if (process.env.NODE_ENV === 'development' || origin.indexOf('ngrok.xiaomiqiu123.top') >= 0) return ''
  const str = url || location.host;
  const arr = str.split('.');
  if (arr.length > 3) {
    // 团队域名形如 teamUrl.material-test.bujue.art / teamUrl.at.bujue.art，前缀是第一段
    return arr[0];
  }
  return '';
}
export const getUrl = () => {
  const origin = window.location.origin;
  if (process.env.NODE_ENV === 'development' || origin.indexOf('ngrok.xiaomiqiu123.top') >= 0) {
    return origin + '/';
  }
  let url = `https://${ym_url.test}/`;
  if (origin.indexOf(ym_url.pre) >= 0) {
    url = `https://${ym_url.pre}/`;
  } else if (origin.indexOf(ym_url.test) < 0) {
    if (origin.indexOf(ym_url.ls) >= 0) {
      return `https://${ym_url.ls}/`;
    }
    url = `https://${ym_url.prod}/`;
  }
  return url;
}
export const getHostName = () => {
  let url = ym_url.test;
  const origin = window.location.origin;
  if (origin.indexOf(ym_url.pre) >= 0) {
    url = ym_url.pre;
  } else if (origin.indexOf(ym_url.test) < 0) {
    if (origin.indexOf(ym_url.ls) >= 0) {
      return ym_url.ls;
    }
    url = ym_url.prod;
  }
  return url;
}
export const getHostUrl = () => {
  return getHostName() + '/';
}
// 是否不是团队页面
const isTeamFun = (url) => {
  const str = getPageUrl(url);
  const find = teamRoute.find(item => str.indexOf(item) >= 0)
  return find;
}
const getPageUrl = (url) => {
  const arr = url.split('/');
  const len = arr.length;
  let last = arr[len - 1]
  if (url.indexOf('.html#/') >= 0) {
    last = arr[len - 2] + '/' + arr[len - 1]
  } else {
    if (last.indexOf('.html') < 0 && len > 4) {
      last = arr[len - 3] + '/' + arr[len - 2] + '/' + arr[len - 1];
    }
  }
  return last;
}
// 把上次登录地址的域名去掉
export function getLastOrigin(url) {
  if (!url) return '/';
  const isTeam = isTeamFun(url);
  const str = getPageUrl(url);
  const arr = url.split('/');
  let hostname = location.host;
  if (arr.length > 3) {
    hostname = arr[2];
  }
  const prefix = isPrefix(hostname);
  if (prefix && isTeam && process.env.NODE_ENV !== 'development') {
    return url
  } else {
    return getUrl() + str;
  }
}

// file: File()
export function compressImage(file, maxWidth, maxHeight, quality, callback) {
  try {
    var reader = new FileReader();
    reader.onload = function (event) {
      var image = new Image();
      image.src = event.target.result;
      image.onload = function () {
        var canvas = document.createElement('canvas');
        var width = image.width;
        var height = image.height;

        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext('2d');
        // 抗锯齿 曲线圆滑
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(image, 0, 0, width, height);

        var compressedDataUrl = canvas.toDataURL('image/png', quality);
        callback(compressedDataUrl);
      };
      image.onerror = function () {
        callback('');
      };
    };
    reader.onerror = function () {
      callback('');
    };
    reader.readAsDataURL(file);
  } catch (e) {
    console.log(e)
  }
}

// file: File()
export function compressImagePromise(file, maxWidth, maxHeight, quality, type='image/jpeg') {

  return new Promise(resolve => {
    try {
      var reader = new FileReader();
      reader.onload = function (event) {
        var image = new Image();
        image.src = event.target.result;
        image.onload = function () {
          var canvas = document.createElement('canvas');
          var width = image.width;
          var height = image.height;

          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;
          var ctx = canvas.getContext('2d');
          // 抗锯齿 曲线圆滑
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.drawImage(image, 0, 0, width, height);

          var compressedDataUrl = canvas.toDataURL(type, quality);
          resolve(compressedDataUrl);
        };

        image.onerror = function () {
          resolve('');
        };
      };

      reader.onerror = function () {
        resolve('');
      };

      reader.readAsDataURL(file);
    } catch (e) {
      resolve('');
    }
  });
}

export function getUrlToBase64Image(imgUrl, maxWidth, maxHeight, quality, callback) {
  let xhr = new XMLHttpRequest();
  xhr.open('get', imgUrl, true);
  xhr.responseType = 'blob';
  xhr.onload = function () {
    if (this.status == 200) {
      let blob = this.response;
      compressImage(blob, maxWidth, maxHeight, quality, callback)
    }
  };
  xhr.send();
}
export function base64ToFile(url, filename) {
  let parts = url.split(","); // data:[<mime type>][;charset=<charset>][;base64],<encoded data>
  let mime = parts[0].match(/:(.*?);/)?.[1];
  let base64Encoded = parts[0].indexOf("base64") > -1;
  let bstr = parts[1];
  base64Encoded && (bstr = window.atob(bstr));
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  const hz = mime?.split('/')?.[1];
  return new File([u8arr], `${filename}.${hz}`, {
    type: mime,
  });
}

// file 传视频地址或视频文件File()
// 部分编码(典型如 HEVC/H.265)硬件解码较慢，seek 到目标帧完成的时间不确定：
// 之前只监听 oncanplay + 固定 200ms 延迟去截帧，canplay 只代表"够开始播放"，不代表 seek 目标帧已经解码完成，
// 慢的话截到的还是 seek 前的帧甚至黑帧，快的话 canplay 可能压根不会因为这次 seek 再触发一次，导致 Promise 一直不 resolve。
// 改为等 loadedmetadata 拿到有效 duration/宽高后再 seek，用 seeked 事件确认目标帧已就绪；
// 同时补 onerror 和超时兜底，避免解码失败/挂起时调用方一直卡住拿不到结果。
// 另外把 video 挂到不可见的 DOM 节点里再解码：不挂载的 video 元素在部分浏览器/编码(尤其硬件解码的 HEVC)下会跳过实际解码，
// 导致截出来的还是黑帧——这也是"上传时截不到第一帧，但上传完成后进详情页能正常预览播放"的原因，预览时 video 是挂在 DOM 里的。
export function videoCaptureFrame(file, time = 1, quality = 0.8) {
  return new Promise((resolve, reject) => {
    try {
      let video = document.createElement('video')
      const objectUrl = (typeof file === 'object') ? URL.createObjectURL(file) : null
      video.src = objectUrl || file
      // 只需要截一帧，不需要 auto 那样尽量多缓冲整段视频，metadata 够用就好，减少不必要的网络等待
      video.preload = 'metadata'
      video.muted = true
      video.playsInline = true
      video.crossOrigin = 'Anonymous'
      video.controls = false
      // 挪到屏幕外(left:-9999px)+ 1px 大小会导致部分编码被浏览器判定为"视口外/极小尺寸"而跳过真实解码，
      // 改成留在可视区域内、只是完全透明(opacity:0)+ 不接收事件
      video.style.cssText = 'position:fixed;left:0;top:0;width:100vw;height:100vh;opacity:0;pointer-events:none;z-index:-1;'
      document.body.appendChild(video)

      let settled = false
      const finish = (fn, arg) => {
        if (settled) return
        settled = true
        clearTimeout(safetyTimer)
        if (objectUrl) URL.revokeObjectURL(objectUrl)
        video.remove()
        fn(arg)
      }
      // 兜底：解码异常/卡住时 10s 后收尾。这里 resolve 空值而不是 reject——
      // 一是保持和旧行为兼容(旧版解不出编码时是 resolve 退化空图，不抛错)，另外 8 处调用方不用改;
      // 二是上传封面这条链路靠 await 结果后 isValidCapturedFrame 判定失败再走 ffmpeg 兜底，
      // 若这里 reject 抛错会直接跳过兜底判断，导致没装解码器时进不了 ffmpeg。
      const safetyTimer = setTimeout(() => {
        finish(resolve, '')
      }, 10000)

      video.onerror = () => {
        finish(resolve, '')
      }

      video.onloadedmetadata = async () => {
        // 有些硬件解码器只有真正 play 过才会启动解码管线，单纯 seek 不会触发解码。
        // play() 的 Promise resolve 只代表"播放请求被接受"，不代表已经解出一帧，紧接着 pause()
        // 很可能在任何一帧真正渲染前就打断了解码，所以用 requestVideoFrameCallback 等到真的有一帧
        // 渲染出来再暂停(不支持的浏览器降级用 playing 事件 + 超时兜底)。
        try {
          await video.play()
          await new Promise((res) => {
            if (video.requestVideoFrameCallback) {
              video.requestVideoFrameCallback(() => res())
            } else {
              video.addEventListener('playing', () => res(), { once: true })
            }
            setTimeout(res, 800)
          })
          video.pause()
        } catch (e) {
          // play 被拒绝(极少数场景)不影响后续 seek 尝试
        }
        video.currentTime = time > video.duration ? video.duration : time
      }

      video.onseeked = () => {
        //苹果浏览器 fireFox 视频第一帧黑屏问题，延迟100ms
        setTimeout(() => {
          try {
            let canvas = document.createElement('canvas')
            canvas.width = video.videoWidth
            canvas.height = video.videoHeight
            canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height)
            let imgUrl = canvas.toDataURL('image/jpeg', quality)
            finish(resolve, imgUrl)
          } catch (error) {
            // 同上：截帧异常也 resolve 空值而不是 reject，保持不抛错、让上层走 ffmpeg 兜底
            finish(resolve, '')
          }
        }, 200)
      };

      video.load()
    } catch (error) {
      reject(error)
    }
  })
}

// videoCaptureFrame 在浏览器无法解码某些编码(如 HEVC)时，会用一个 0x0 的空画布"成功" resolve 出一个
// 只有 "data:," 6 个字符的退化图片(而不是 reject)——这是刻意保留的旧行为，避免影响其它已有调用方
// (它们大多没有对 reject 做容错，贸然改成 reject 可能让 Promise.all 之类的批量流程整体失败)。
// 需要区分"真的截到帧"还是"退化空图"的调用方(比如失败后要重试)用这个函数判断。
export function isValidCapturedFrame(dataUrl) {
  return !!dataUrl && dataUrl.length > 100
}

// 判断本地 File/Blob 是否为 HEVC(H.265) 编码的视频。
// MP4 视频轨 sample entry 的 fourcc 是 hvc1/hev1(H.264 是 avc1/avc3、AV1 是 av01)，按 ASCII 字节搜文件内容即可，
// 不用解析 moov box 层级；这两个 fourcc 只用于 HEVC 轨，误报风险极低。
// moov 在 faststart 文件里位于开头、普通文件里位于末尾，所以开头/末尾各扫一段。
// 用途：handleCompressVideo 判定是否转码时，HEVC 即使比转码目标还小也必须转码成 H.264(浏览器普遍解不了 HEVC 原码)，
// 否则会被"文件够小就不压缩"的逻辑误判为 Origin 不转码。
export async function isHEVCFile(file, headBytes = 16 * 1024 * 1024, tailBytes = 16 * 1024 * 1024) {
  try {
    console.log('[HEVC_COMPRESS] isHEVCFile called | name =', file?.name, '| size =', file?.size, '| hasSlice =', typeof file?.slice === 'function')
    if (!file || typeof file.slice !== 'function' || !file.size) return false
    const scan = async (start, length) => {
      const end = Math.min(start + length, file.size)
      if (start >= end) return false
      const data = new Uint8Array(await file.slice(start, end).arrayBuffer())
      const s = new TextDecoder('latin1').decode(data)
      return s.includes('hvc1') || s.includes('hev1') || s.includes('HVC1') || s.includes('HEV1')
    }
    if (await scan(0, headBytes)) { console.log('[HEVC_COMPRESS] isHEVCFile hit HEAD'); return true }
    // 非 faststart(未把 moov 挪到文件头)时 sample entry 在文件尾部
    if (file.size > headBytes && await scan(Math.max(0, file.size - tailBytes), tailBytes)) { console.log('[HEVC_COMPRESS] isHEVCFile hit TAIL'); return true }
    console.log('[HEVC_COMPRESS] isHEVCFile no hvc1/hev1 found in head/tail')
    return false
  } catch (e) {
    console.error('[HEVC_COMPRESS] isHEVCFile EXCEPTION:', e)
    return false
  }
}

// videoCaptureFrame 依赖浏览器原生 <video> 解码，遇到浏览器解不了的编码(如 HEVC)只能退化 resolve 空图。
// ffmpeg.wasm 自带解码器，不受浏览器编码支持限制，作为兜底：只在 videoCaptureFrame 失败时才用，
// 避免让所有场景都背上 ffmpeg-core(几十MB)的开销。只接受本地 File/Blob，直接读文件内容，不用等上传/依赖远程地址。
//
// @ffmpeg/ffmpeg 的 ESM 入口会被 Webpack/Rspack 纳入依赖图，并自动产出其 module worker，
// 不再依赖 dist/ffmpeg/ 下的未带 hash 静态文件，避免发布环境遗漏该目录造成 404。
//
// core 的 js/wasm 不受同源限制：是走 fetch() 转 blob URL 用的(见 toBlobURL)，只要 CDN 带 CORS 头
// 就能正常跨域拉取，所以 core 固定走 CDN，不用 webpack 复制 @ffmpeg/core 的产物。
const FFMPEG_CORE_JS_URL = 'https://bujue-static-cdn.bujue.art/npm/@ffmpeg/core@0.12.10/dist/umd/ffmpeg-core.js'
const FFMPEG_CORE_WASM_URL = 'https://bujue-static-cdn.bujue.art/npm/@ffmpeg/core@0.12.10/dist/umd/ffmpeg-core.wasm'
const FFMPEG_FRAME_TASK_TIMEOUT = 35000
const FFMPEG_WORKER_POOL = Array.from({ length: 2 }, (_, index) => ({
  id: index + 1,
  loadPromise: null,
  busy: false,
}))
const ffmpegPendingTasks = []

// 把资源 fetch 成同源 blob URL(经典 worker importScripts / emscripten locateFile 都能用)；
// 支持跨域地址(如 CDN)，只要目标带 CORS 头
async function toBlobURL(url, mimeType) {
  const buf = await (await fetch(url)).arrayBuffer()
  return URL.createObjectURL(new Blob([buf], { type: mimeType }))
}

// core 的 js/wasm blob URL 在 worker 实例池之外单独缓存：某个 worker 崩溃或超时后会重建实例，
// 但无需重新从 CDN 拉取 core 文件。
let ffmpegCoreBlobURLsPromise = null
function getFFmpegCoreBlobURLs() {
  if (!ffmpegCoreBlobURLsPromise) {
    ffmpegCoreBlobURLsPromise = Promise.all([
      toBlobURL(FFMPEG_CORE_JS_URL, 'text/javascript'),
      toBlobURL(FFMPEG_CORE_WASM_URL, 'application/wasm'),
    ]).then(([coreURL, wasmURL]) => ({ coreURL, wasmURL })).catch((e) => {
      ffmpegCoreBlobURLsPromise = null // 失败后允许下次重试
      throw e
    })
  }
  return ffmpegCoreBlobURLsPromise
}

function getFFmpeg(workerSlot) {
  if (!workerSlot.loadPromise) {
    workerSlot.loadPromise = (async () => {
      const ffmpeg = new FFmpeg()
      const { coreURL, wasmURL } = await getFFmpegCoreBlobURLs()
      await ffmpeg.load({ coreURL, wasmURL })
      return ffmpeg
    })().catch((e) => {
      workerSlot.loadPromise = null // 失败后允许下次重试
      throw e
    })
  }
  return workerSlot.loadPromise
}

async function terminateFFmpegPromise(workerSlot, ffmpegPromise) {
  if (workerSlot.loadPromise === ffmpegPromise) workerSlot.loadPromise = null
  if (!ffmpegPromise) return
  try {
    const ffmpeg = await ffmpegPromise
    try { ffmpeg.terminate() } catch (e) { console.error('ffmpeg terminate failed', e) }
  } catch (e) {
    // 加载失败时没有可终止的 worker
  }
}

// 所有截帧任务进入公共队列，任一空闲 worker 都可取下一个任务；单个 worker 内仍串行执行。
export function videoCaptureFrameByFFmpeg(file, time = 1, quality = 0.8) {
  return new Promise(resolve => {
    ffmpegPendingTasks.push({
      file,
      time,
      quality,
      attempt: 1,
      avoidWorkerId: null,
      queuedAt: performance.now(),
      resolve,
    })
    dispatchFFmpegTasks()
  })
}

function dispatchFFmpegTasks() {
  FFMPEG_WORKER_POOL.filter(slot => !slot.busy).forEach(workerSlot => {
    if (!ffmpegPendingTasks.length) return
    let taskIndex = ffmpegPendingTasks.findIndex(task => task.avoidWorkerId !== workerSlot.id)
    if (taskIndex < 0) taskIndex = 0
    const task = ffmpegPendingTasks.splice(taskIndex, 1)[0]
    workerSlot.busy = true
    runFFmpegTask(workerSlot, task).finally(() => {
      workerSlot.busy = false
      dispatchFFmpegTasks()
    })
  })
}

async function runFFmpegTask(workerSlot, task) {
  let timeoutId
  let taskFFmpegPromise
  const captureTask = captureFrameByFFmpeg(task.file, task.time, task.quality, promise => {
    taskFFmpegPromise = promise
  }, workerSlot)
  const timeoutTask = new Promise(resolve => {
    timeoutId = setTimeout(async () => {
      await terminateFFmpegPromise(workerSlot, taskFFmpegPromise)
      resolve('')
    }, FFMPEG_FRAME_TASK_TIMEOUT)
  })
  let frame = ''
  try {
    frame = await Promise.race([captureTask, timeoutTask])
  } catch (e) {
    frame = ''
  } finally {
    clearTimeout(timeoutId)
  }
  if (frame || task.attempt >= 2) {
    task.resolve(frame || '')
    return
  }
  ffmpegPendingTasks.push({
    ...task,
    attempt: task.attempt + 1,
    avoidWorkerId: workerSlot.id,
    queuedAt: performance.now(),
  })
}

// time 参数保留是为了和 videoCaptureFrame 签名一致(调用方通用)，ffmpeg 这条只截第一帧不用它
// eslint-disable-next-line no-unused-vars
async function captureFrameByFFmpeg(file, time = 1, quality = 0.8, setTaskFFmpegPromise, workerSlot) {
  // 容错：ffmpeg.js/worker/core 加载失败时(如测试环境漏部署 dist/ffmpeg/ 或 CDN 拉取失败)降级 resolve 空图，
  // 不 reject —— 上层调用方(isValidCapturedFrame 判定失败才走到这里)没有 try/catch，reject 会直接中断上传/状态更新流程。
  let ffmpeg
  const currentFFmpegPromise = getFFmpeg(workerSlot)
  setTaskFFmpegPromise(currentFFmpegPromise)
  try {
    ffmpeg = await currentFFmpegPromise
  } catch (e) {
    return ''
  }
  // 绝对路径写到 MEMFS 根目录，排除相对路径 CWD 干扰
  const outputName = '/output.jpg'
  // 用 WORKERFS 挂载而不是 writeFile：writeFile 会把整个视频(几十MB)拷进 wasm 线性内存，
  // 初始堆才 32MB，一写就触发内存增长/ArrayBuffer detach，core 拿旧视图访问就 "memory access out of bounds"。
  // WORKERFS 让 ffmpeg 直接从 File(Blob)按需读取，不占 wasm 堆，绕开这个内存问题。
  const mountDir = '/mnt'
  const inputPath = `${mountDir}/${file.name}`
  // 0.8 对应的清晰度大致映射到 ffmpeg -q:v 的 2(最好)~31(最差) 范围
  const qValue = Math.min(31, Math.max(2, Math.round(2 + (1 - quality) * 29)))
  let mounted = false
  let execCrashed = false
  try {
    await ffmpeg.createDir(mountDir)
    await ffmpeg.mount('WORKERFS', { files: [file] }, mountDir)
    mounted = true
    // 只截第一帧(不 -ss 定位)：第一帧必是关键帧。封面最长边限制为 1280，并强制解码/滤镜单线程，
    // 避免高分辨率 HEVC 在 swscale + mjpeg 阶段产生过高峰值内存导致 wasm memory access out of bounds。
    // 这个 core 有两个坑，组合起来绕过：
    //   1) image2 muxer 彻底坏了(打不开任何文件，"Could not open file")→ 只能用 mjpeg raw muxer(它能打开能写)。
    //   2) ffmpeg 退出/清理阶段必崩(RuntimeError: null function)，跳过了 avio_close 的最终刷盘 →
    //      mjpeg muxer 缓冲的帧没刷到文件，读出来 0 字节。用 -flush_packets 1 强制每个包写完立即刷盘(avio_flush)，
    //      帧在崩之前就落到 /output.jpg 里，就能读出来。
    // 绝对路径 /output.jpg(mjpeg muxer 能正常打开)；-an 丢音频、-nostdin 防交互；第二参 timeout(30s) 兜底。
    try {
      await ffmpeg.exec(
        [
          '-nostdin',
          '-threads', '1',
          '-filter_threads', '1',
          '-i', inputPath,
          '-frames:v', '1',
          '-an',
          '-vf', 'scale=1280:-2:force_original_aspect_ratio=decrease',
          '-q:v', String(qValue),
          '-flush_packets', '1',
          '-f', 'mjpeg',
          outputName,
        ],
        30000
      )
    } catch (e) {
      // ffmpeg 退出阶段的 "null function" 崩溃：帧已被 -flush_packets 刷进文件了，不当致命错误，继续往下读；
      // 但记下崩溃标记，读完后销毁实例(worker 里 n.reset() 没执行，core 状态可能坏了)。
      execCrashed = true
    }
    const data = await ffmpeg.readFile(outputName)
    if (!data || !data.length) {
      return ''
    }
    // 直接传 Uint8Array(而不是它的 .buffer)：readFile 返回的可能是某个更大 ArrayBuffer 的子视图，
    // 用 .buffer 会连带把视图之外的字节也塞进 Blob，Blob 构造函数本身能正确处理 TypedArray 的 byteOffset/length
    const blob = new Blob([data], { type: 'image/jpeg' })
    return await new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => resolve(reader.result)
      reader.onerror = reject
      reader.readAsDataURL(blob)
    })
  } catch (e) {
    return ''
  } finally {
    if (execCrashed) {
      // exec 抛异常时 worker 里的 n.reset() 没执行，core 状态可能坏了，销毁 worker 让下次调用重建，
      // 避免复用坏实例导致后续视频截帧出错
      try { ffmpeg.terminate() } catch (e) { console.error('ffmpeg terminate failed', e) }
      if (workerSlot.loadPromise === currentFFmpegPromise) workerSlot.loadPromise = null
    } else {
      if (mounted) { try { await ffmpeg.unmount(mountDir) } catch (e) { console.error('ffmpeg unmount failed', e) } }
      try { await ffmpeg.deleteDir(mountDir) } catch (e) { console.error('ffmpeg deleteDir failed', e) }
      try { await ffmpeg.deleteFile(outputName) } catch (e) { console.error('ffmpeg deleteFile failed', e) }
    }
  }
}

export const videoFrameImg = async (file, time, quality) => {
  const url = await videoCaptureFrame(file, time, quality)
  const formdata = new FormData();
  const fil = base64ToFile(url, "图片");
  formdata.append("files", fil);
  return new Promise((resolve, reject) => {
    multipartUpload(formdata).then((res) => {
      if (res.success) {
        resolve(res.result);
      } else {
        reject(false);
        message.error(res.error);
      }
    });
  });
};

export function isMP4Video(url) {
  if (url) {
    const urlArr = url?.split('.')
    const suffix = urlArr[urlArr?.length - 1]
    return suffix === 'mp4' || suffix === 'MP4'
  }
}

/**
 * 获取 blob
 * @param  {String} url 目标文件地址
 * @return {cb}
 */
export function getBlob(url, cb) {
  let xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.onload = function () {
    if (xhr.status === 200) {
      cb(xhr.response);
    }
  };
  setTimeout(() => {
    xhr.send();
  }, 0)
}
/**
 * 保存
 * @param  {Blob} blob
 * @param  {String} filename 想要保存的文件名称
 */
export function saveAs(blob, filename, fileType = null, noReplaceName = false) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, filename);
    return true;
  } else {
    let link = document.createElement('a');
    let body = document.querySelector('body');

    link.href = window.URL.createObjectURL(blob);
    let _fileName = filename
    if(filename.indexOf('.')>=0 && !noReplaceName){
      _fileName = filename.replaceAll(/\./g,'_');
    }
    if (fileType) {
      if (_fileName.indexOf('.') === -1) {
        _fileName = _fileName + '.' + fileType
      }
    }
    link.download = _fileName;

    // fix Firefox
    link.style.display = 'none';
    body.appendChild(link);

    link.click();
    try {
      body.removeChild(link);
    } catch (e) {
      console.log(e)
    }

    window.URL.revokeObjectURL(link.href);
    return true;
  }
}
/**
 * 下载
 * @param  {String} url 目标文件地址
 * @param  {String} filename 想要保存的文件名称
 * @param  {String} fileType 文件格式
 */
export function download(url, filename, fileType = null,noReplaceName) {
  return new Promise((resolve) => {
    getBlob(url, function (blob) {
      let type = fileType
      // 取文件后缀
      if(!fileType){
        const arr = url.split('.');
        if(arr?.length>0){
          type = arr[arr.length-1]
        }
      }
      const flag = saveAs(blob, filename, type,noReplaceName)
      resolve(flag);
    });
  })

}

export function downloadFile(url, fileName, fileType = null) {
  return new Promise(async (resolve) => {
    if (!url) {
      resolve(false);
      return
    }
    if (fileName) {
      const flag = await download(url, fileName, fileType);
      resolve(flag);
    } else {
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none'; // 防止影响页面
      iframe.style.height = 0; // 防止影响页面
      iframe.src = url;
      document.body.appendChild(iframe);
      setTimeout(() => {
        iframe.remove();
      }, 180000);
      resolve(true);
    }
  })

}

// 判断是否有参数
export function isHadParam(url) {
  const reg = /\?./;
  let str = "?";
  // 判断是否有参数
  if (reg.test(url)) {
    str = "&";
  }
  return str;
}


// 解码url
export function getDecodeUrl(url) {
  const encodedRegex = /(%[0-9A-F]{2})+/i;
  if (encodedRegex.test(url)) {
    return decodeURIComponent(url);
  }
  return url;
}
// 判断是否是微信环境
export function judge() {
  const ua = navigator.userAgent.toLowerCase()
  return ua.indexOf('micromessenger') !== -1 // true or false
}



export function toHWYQuality(url, quality = '?x-oss-process=image/resize,w_2000,h_2000/quality,q_80') {
  if (!url || (url?.indexOf('?x-oss-process=image') !== -1)) return url
  const size = isHadSize(url);
  if (size && ((size / 1024 / 1024) >= 25)) {
    return url
  }
  return url + quality
}

export function localImageSizeIsUpload(file, imageWidth = uploadImageWidthAndHeightLimit.width, imageHeight = uploadImageWidthAndHeightLimit.height) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = function (event) {
      let image = new Image();
      image.src = event.target.result;
      image.onload = function () {
        let width = image.width;
        let height = image.height;
        resolve(width < imageWidth && height < imageHeight)
      };

      image.onerror = function () {
        resolve(false);
      };
    };

    reader.onerror = function (error) {
      reject(error);
    };

    reader.readAsDataURL(file);
  });
}

export function fileNameCompare(s1, s2) {
  function isChinese(char) {
    return /^[\u4E00-\u9FA5]+$/.test(char);
  }

  let i1 = 0, i2 = 0;

  while (i1 < s1.length && i2 < s2.length) {
    let c1 = s1.charAt(i1), c2 = s2.charAt(i2);

    if (isChinese(c1) && !isChinese(c2)) {
      return 1;
    } else if (!isChinese(c1) && isChinese(c2)) {
      return -1;
    } else if (/\d/.test(c1) && /\d/.test(c2)) {
      let num1 = 0, num2 = 0;

      while (i1 < s1.length && /\d/.test(s1.charAt(i1))) {
        num1 = num1 * 10 + (s1.charAt(i1) - '0');
        i1++;
      }

      while (i2 < s2.length && /\d/.test(s2.charAt(i2))) {
        num2 = num2 * 10 + (s2.charAt(i2) - '0');
        i2++;
      }

      if (num1 !== num2) {
        return num1 - num2;
      }
    } else if (c1 === c2) {
      i1++;
      i2++;
    } else if (c1 === '.' || c2 === '.') {
      if (c1 === '.') {
        return -1;
      } else if (c2 === '.') {
        return 1;
      } else {
        return c1.localeCompare(c2);
      }
    } else {
      return c1.localeCompare(c2);
    }
  }

  return s1.length - s2.length;
}

export function getImageSizeFromUrlAddress(url) {
  const regex = /_\d+x\d+_/;
  const match = url.match(regex);
  let result = [];
  if (match !== null) {
    const size = match[0].substring(1, match[0].length - 1);
    result.push(size.split('x')[0])
    result.push(size.split('x')[1])
  }
  return result;
}

export async function getImageInfoFormHuaweiCloud(url) {
  let result = [];
  try {
    let res = await axios({
      method: "GET",
      url: url + '?x-oss-process=image/info',
    })
    if (res.status === 200) {
      const data = res.data
      result = [data.width, data.height];
    } else {
      result = getImageSizeFromUrlAddress(url)
    }
    return result;
  } catch (e) {
    result = getImageSizeFromUrlAddress(url)
    return result;
  }
}

export async function getImageInfoFormAliCloud(url) {
  let result = [];
  try {
    let res = await axios({
      method: "GET",
      url: url + '?x-oss-process=image/info',
    })
    if (res.status === 200) {
      const data = res.data
      if (data.Orientation && (data.Orientation.value === '6' || data.Orientation.value === '8')) {
        result = [data.ImageHeight.value, data.ImageWidth.value]
      } else {
        result = [data.ImageWidth.value, data.ImageHeight.value];
      }
    } else {
      result = getImageSizeFromUrlAddress(url)
    }
    return result;
  } catch (e) {
    result = getImageSizeFromUrlAddress(url)
    return result;
  }
}

// 判断资材数据是否不完整 return true则不完整
export function getProductIsNotAll(data) {
  const { covers, name, privateType, privateTopTypeId, privateSecondTypeId, type, topTypeId, secondTypeId, designStyles } = data;
  let isSuc = true;
  if (designStyles?.length) {
    designStyles.forEach(item => {
      // if (!item?.model || !item?.covers?.length) isSuc = false;
      if (!item?.covers?.length) isSuc = false;
    })
  } else {
    isSuc = false;
  }
  return !covers?.length || !name || !privateType || !privateTopTypeId || !privateSecondTypeId || !type || !topTypeId || !secondTypeId || !isSuc;
}

// 批量导入（/api/teamMix/batchImport）失败时，从 result.failProducts 中提取 checkInfo（如"敏感词审核不通过"），去重后拼接用于提示
export function getBatchImportCheckInfo(result) {
  if (!result?.failProducts?.length) return "";
  const checkInfoList = result.failProducts
    .map((p) => p?.checkInfo)
    .filter((v) => typeof v === "string" && v.trim());
  return [...new Set(checkInfoList)].join("、");
}

export const downloadFileAuto = (filename, url) => {
  let a = document.createElement('a');
  a.style = 'display: none'; // 创建一个隐藏的a标签
  a.download = filename;
  a.target = "_blank";
  a.href = url;
  document.body.appendChild(a);
  a.click(); // 触发a标签的click事件
  try {
    document.body.removeChild(a);
  } catch (e) {
    console.log(e)
  }

}
export function getCurrentTimestamp() {
  return new Date().getTime()
}

export function getLocalImageSize(file) {
  return new Promise(resolve => {
    let reader = new FileReader()
    reader.onload = event => {
      let image = new Image()
      image.src = event.target.result
      image.onload = () => {
        resolve(`${image.width}x${image.height}`)
      };
      image.onerror = () => {
        resolve('0x0')
      };
    };
    reader.onerror = () => {
      resolve('0x0')
    }
    reader.readAsDataURL(file)
  })
}

// 正则匹配：将中文简繁体、大小写英文、数字、点、下划线以外的字符转为下划线
export function replaceIllegalChar(filename) {
  return filename.replace(/[^\u4e00-\u9fa5a-zA-Z0-9._]/g, '_');
}

export async function generateRandomFilePath(file, rename = null) {
  let isImageType = file.type.startsWith('image')
  let fileSize = file.size
  let imageSize = '0x0'
  if (isImageType) {
    imageSize = await getLocalImageSize(file)
  }
  let name = replaceIllegalChar(file.name);
  if (rename) {
    const fileSuffix = file.name.split('.').pop();
    name = rename + '.' + fileSuffix;
  }
  return `${getCurrentTimestamp()}_${fileSize}byte_${imageSize}_${name}`
}

// 华为对象存储
// progressCallback function (transferredAmount, totalAmount, totalSeconds) {
//    获取上传平均速率（KB/S）: transferredAmount * 1.0 / totalSeconds / 1024
//    获取上传进度百分比: transferredAmount * 100.0 / totalAmount
// }
export function uploadHwObs(file, progressCallback = null, extendedInformation = null, rename) {
  return new Promise(async resolve => {
    try {
      let filePath = await generateRandomFilePath(file, rename)
      const obsClient = new ObsClient({
        access_key_id: bujueDecrypt(process.env.TEST_HW_OBS_ACCESS_KEY),
        secret_access_key: bujueDecrypt(process.env.TEST_HW_OBS_SECRET_KEY),
        server: hwObsConfigInfo.end_point,
      })
      obsClient.putObject({
        Bucket: hwObsConfigInfo.bucket_name,
        Key: filePath,
        SourceFile: file,
        ProgressCallback: progressCallback
      }, async (error, result) => {
        if (error) {
          resolve({
            success: false,
            errorInfo: error,
            result: null
          })
        } else {
          if (result.CommonMsg.Status === 200) {
            let url = hwObsConfigInfo.domain_name + '/' + filePath
            let fileName = file.name
            resolve({
              success: true,
              errorInfo: '',
              result: url
            })
            if (extendedInformation) {
              await copyOriginToCloud({
                type: extendedInformation?.type,
                wid: extendedInformation?.wid,
                name: fileName,
                owner: extendedInformation?.owner,
                fileType: file.name.split('.').slice(-1)[0],
                size: file.size,
                obsUrl: url,
                coverUrl: null,
                key: filePath
              })
            }
            compressedMedia(file, url)
          } else {
            resolve({
              success: false,
              errorInfo: result.CommonMsg.Status,
              result: null
            })
          }
        }
      });
    } catch (error) {
      resolve({
        success: false,
        errorInfo: error,
        result: null
      })
    }
  })
}

export async function workdisplayinfoUploadingTip() {
  const { t } = useTranslation()
  message.info(t(unsavedTip.tip_three))
}

export function determineTheUploadUser() {
  let result = false
  if (sessionStorage.getItem('workIdAndUploadUserId') !== null) {
    let userId = currentUser()?.id
    let workIdAndUploadUserId = sessionStorage.getItem('workIdAndUploadUserId')
    let uploadWorkId = workIdAndUploadUserId.split('_')[0]
    let uploadUserId = workIdAndUploadUserId.split('_')[1]
    if (uploadUserId == userId && uploadWorkId == sessionStorage.getItem('workId')) {
      result = true
    }
  }
  return result
}

// 作品上/不觉云传中用于作品库/不觉云之外的点击判断，是否中断上传
export async function handleWorkdisplayinfoExistExtraInfoOrUploading(nextFun, opacity = 1) {
  const { t } = useTranslation()
  if (window.cloudDiskUploadFileListIsUploading) {
    Modal.confirm({
      className: `works-confirm-model ${opacity ? "" : "works-confirm-model-drak"}`,
      title: t('提示'),
      content: t(unsavedTip.tip_two),
      okText: t('确定'),
      cancelText: t('取消'),
      closable: true,
      onOk: () => {
        window.cloudDiskUploadFileList = {}
        window.cloudDiskUploadFileListIsUploading = false
        nextFun()
        return
      },
      onCancel: () => { }
    });
    return
  }

  if (sessionStorage.getItem('workId') === null) {
    nextFun()
    return
  }

  let modalContent = unsavedTip.tip_one
  let isEdit = false
  if (sessionStorage.getItem('worksStatus') === 'edit') {
    isEdit = sessionStorage.getItem('worksInfomationEdit') === '1'
  }
  if (sessionStorage.getItem('worksStatus') === 'create') {
    let isExistExtraInfoData = await workdisplayinfoExistExtraInfo(sessionStorage.getItem('workId'))
    if (isExistExtraInfoData) {
      isEdit = true
    }
    if (!isEdit) {
      isEdit = sessionStorage.getItem('worksInfomationEdit') === '1'
    }
  }
  let isCompleted = true
  if (determineTheUploadUser()) {
    isCompleted = await workdisplayinfoUploadingIsCompleted(sessionStorage.getItem('workId'))
  }
  if (!isCompleted) {
    isEdit = true
    modalContent = unsavedTip.tip_two
  }
  if (isEdit) {
    Modal.confirm({
      className: `works-confirm-model ${opacity ? "" : "works-confirm-model-drak"}`,
      title: t('提示'),
      content: t(modalContent),
      okText: t('确定'),
      cancelText: t('取消'),
      closable: true,
      onOk: () => {
        handleGoNext()
      },
      onCancel: () => { }
    });
  } else {
    handleGoNext()
  }

  function handleGoNext() {
    sessionStorage.setItem('worksStatus', 'watch')
    sessionStorage.setItem('worksInfomationEdit', 0)
    setTimeout(() => {
      sessionStorage.removeItem('workId')
    }, 300)
    nextFun()
  }
}


function handleSingleAndDoubleHitEvents() {
  let isClick = false;
  let clickNum = 0;
  return function ({ singleClick, doubleClick }) {
    if (!doubleClick) {
      return singleClick && singleClick();
    }

    clickNum++;
    if (isClick) {
      return;
    }
    isClick = true;

    setTimeout(() => {
      if (clickNum > 1) {
        doubleClick && doubleClick();
      } else {
        singleClick && singleClick();
      }
      clickNum = 0;
      isClick = false;
    }, 300);
  };
}
export const onSingleAndDoubleHitEvents = handleSingleAndDoubleHitEvents()

export const bujueEncrypt = (str, key = bujueDecryptKey) => {
  const keys = CryptoJs.enc.Utf8.parse(key)
  const strs = CryptoJs.enc.Utf8.parse(str)
  const encrypted = CryptoJs.AES.encrypt(strs, keys, {
    mode: CryptoJs.mode.ECB,
    padding: CryptoJs.pad.Pkcs7
  })
  return encrypted.toString()
}

export const bujueDecrypt = (str, key = bujueDecryptKey) => {
  const keys = CryptoJs.enc.Utf8.parse(key)
  const decrypt = CryptoJs.AES.decrypt(str, keys, {
    mode: CryptoJs.mode.ECB,
    padding: CryptoJs.pad.Pkcs7
  })
  return CryptoJs.enc.Utf8.stringify(decrypt).toString();
}

export const uploadHwObsRequest = async (options) => { // customRequest // 对 /api/uploadWithQuality 的自定义上传
  const { file, onSuccess } = options;
  const res = await uploadHwObs(file)
  onSuccess(res)
}

export const uploadAliOssRequest = async (options, rename = null) => { // customRequest // 对 /api/uploadWithQuality 的自定义上传
  const { file, onSuccess, data = { Compress: {} } } = options; // data.Compress:压缩参数
  const res = await uploadAliOss(file, true, rename, null, data?.Compress)
  onSuccess(res)
}

export const HwObsUploadSizeLimit = () => {
  return true
  // return new Promise((resolve, reject) => {
  //   localImageSizeIsUpload(file).then((res) => {
  //     if (res) {
  //       resolve()
  //     } else {
  //       message.error('"' + file.name + '"' + uploadTip.tip_two)
  //       reject()
  //     }
  //   }).catch((err) => {
  //     console.log(err)
  //     message.error('图片上传失败')
  //     reject()
  //   })
  // })
}

export const beforeHwObsUpload = (file, fileList, isImg = [], msg = '', isVerifyImageSizeWH = false, minimumSize = 30000, suggestedSize = 30000, returnError = false) => { // 华为云上传限制
  if (fileList.length > maxUploadLimit) {
    let idx = fileList.findIndex(item => { return item.uid === file.uid })
    if (idx === fileList?.length - 1) {
      message.error(uploadTip.tip_one)
    }
    if (idx >= maxUploadLimit) {
      return false
    }
  }
  if (file.type.indexOf('image') !== -1) {
    return isVerifyImageSizeWH ? verifyImageSizeWH(file, fileList, minimumSize, suggestedSize, returnError) : HwObsUploadSizeLimit(file)
  } else if (isImg.length > 0) {
    const find = isImg.find(type => file.type.indexOf(type) >= 0);
    if (!find) {
      message.error(msg || '只允许上传图片！');
      return false
    }
  }
  return true
}

export const swapArrayValues = (arr, index1, index2) => {
  if (index1 >= 0 && index2 >= 0 && index1 < arr.length && index2 < arr.length) {
    let temp = arr[index1];
    arr[index1] = arr[index2];
    arr[index2] = temp;
  }
  return arr
}
export const moveElementInArray = (arr, fromIndex, toIndex) => {
  const element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
  return arr
}
export const layout = () => {
  setCookie("mtoken", "", 7);
  sessionStorage.clear();
  localStorage.clear();
  window.__user__ = null;
  document.cookie.split(";").forEach(function (cookie) {
    document.cookie = cookie
      .replace(/^ +/, "")
      .replace(
        /=.*/,
        "=;expires=" + new Date().toUTCString() + ";path=/"
      );
  });
}
export const initObsClient = () => {
  return new ObsClient({
    access_key_id: bujueDecrypt(process.env.TEST_HW_OBS_ACCESS_KEY),
    secret_access_key: bujueDecrypt(process.env.TEST_HW_OBS_SECRET_KEY),
    server: hwObsConfigInfo.end_point,
  })
}

// 断点续传上传接口传入的文件总大小至少要100K以上
// 华为OBS断点续传参数 https://support.huaweicloud.com/sdk-browserjs-devg-obs/obs_24_0511.html
export const uploadHwObsBreakpointContinuationUpload = (obsClient, file, filePath, progressCallback, resumeCallback, partSize = 9 * 1024 * 1024, taskNum = 9) => {
  return new Promise(async resolve => {
    try {
      // let filePath = await generateRandomFilePath(file)
      obsClient.uploadFile({
        Bucket: hwObsConfigInfo.bucket_name,
        Key: filePath,
        SourceFile: file,
        PartSize: partSize,
        taskNum: taskNum,
        ProgressCallback: progressCallback,
        ResumeCallback: resumeCallback
      }, (error, result) => {
        if (error) {
          resolve({
            success: false,
            errorInfo: error,
            result: null
          })
        } else {
          if (result.CommonMsg.Status === 200) {
            let url = hwObsConfigInfo.domain_name + '/' + filePath
            resolve({
              success: true,
              errorInfo: '',
              result: url
            })
          } else {
            resolve({
              success: false,
              errorInfo: result.CommonMsg.Status,
              result: null
            })
          }
        }
      })
    } catch (error) {
      resolve({
        success: false,
        errorInfo: error,
        result: null
      })
    }
  })
}

// 断点续传继续上传
export const uploadHwObsBreakpointContinuationContinueUpload = (obsClient, filePath, fileUploadInfo, progressCallback, resumeCallback) => {
  return new Promise(async resolve => {
    try {
      // let filePath = await generateRandomFilePath(file)
      obsClient.uploadFile({
        UploadCheckpoint: fileUploadInfo.uploadCheckpoint,
        ProgressCallback: progressCallback,
        ResumeCallback: resumeCallback
      }, (error, result) => {
        if (error) {
          resolve({
            success: false,
            errorInfo: error,
            result: null
          })
        } else {
          if (result.CommonMsg.Status === 200) {
            let url = hwObsConfigInfo.domain_name + '/' + filePath
            resolve({
              success: true,
              errorInfo: '',
              result: url
            })
          } else {
            resolve({
              success: false,
              errorInfo: result.CommonMsg.Status,
              result: null
            })
          }
        }
      })
    } catch (error) {
      resolve({
        success: false,
        errorInfo: error,
        result: null
      })
    }
  })
}

export const handleIsShowFileNameTooltip = (str, fileNameContainerWidth) => {
  const pattern = /[\u4e00-\u9fff]/g
  const result = str ? str.match(pattern) : null;
  const chineseCharacterCount = result ? result.length : 0
  const len = str?.length || 0
  return (chineseCharacterCount * 14 + (len - chineseCharacterCount) * 8) > fileNameContainerWidth
}

// 简单数组去重 [1,2,3]
export const arrayDeduplication = arr => {
  return [...new Map(arr.map(item => [item, item])).values()]
}

// 获取资材文件总量大小
export const getProductSize = (values) => {
  let size = 0;
  if (values?.usageScenariosUrlsV3?.length) {
    const usageScenariosUrlsV2 = values.usageScenariosUrlsV3.map(item => item.usageScenariosUrlsV2).flat()
    usageScenariosUrlsV2.forEach((v) => {
      size += Number(v.size || 0)
    })
  }
  values.coversV2?.forEach((v) => {
    size += Number(v.size || 0)
  })
  values.attachment?.forEach((v) => {
    size += Number(v.size || 0)
  })
  // values?.designStyles?.forEach(val => {
  //   val?.covers?.forEach((v) => {
  //     if (v?.type != 2) size += Number(v.size || 0)
  //   })
  //   val?.relateTextureGroups?.forEach((v) => {
  //     v?.images?.forEach((img) => {
  //       if (img.type === 1) size += Number(img.size || 0)
  //     })
  //   })
  // })
  return size
}

export const containsSpecialChars = (str) => {
  const pattern = /[\\\\/:\\<>\\|\\*\\"?]/;
  return pattern.test(str);
}

export const getGBbyBite = (value, len = 2) => {
  if (value === 0) return 0;
  return parseFloat(value / 1073741824).toFixed(len);
}

// 云盘判断文件夹/文件
export const isFolderInCloudDisk = fileInfo => {
  return Object.keys(fileInfo).includes('folderType')
}

// 产品贴图、委托素材为特殊系统文件夹
export const PROTECTED_CLOUD_DISK_FOLDER_NAMES = ['产品贴图', '委托素材']
export const isProtectedCloudDiskFolder = fileInfo => {
  return !!fileInfo && isFolderInCloudDisk(fileInfo) && PROTECTED_CLOUD_DISK_FOLDER_NAMES.includes(fileInfo.name)
}

// 云盘预览图片支持的格式
export const isImageInCloudDisk = fileType => {
  // const fileSuffix = ['png', 'bmp', 'jpg', 'jpeg', 'gif', 'tif', 'svg', 'webp']
  const fileSuffix = ['png', 'jpg', 'jpeg', 'webp', 'gif'];
  const suffix = fileType.toLowerCase()
  return fileSuffix.indexOf(suffix) >= 0
}

// 云盘预览视频支持的格式
export const isVideoInCloudDisk = fileType => {
  // 无法预览 avi mpg wmv mpeg格式
  const fileSuffix = ['mp4', 'mov', 'm4v'];
  const suffix = fileType.toLowerCase()
  return fileSuffix.indexOf(suffix) >= 0
}

// 云盘预览支持的格式
export const isSupportPreview = fileType => {
  const fileSuffix = ['pdf', 'docx', 'doc', 'xlsx', 'xls', 'pptx', 'ppt', 'zip', 'jpg', 'png', 'jpeg', 'tiff', 'mp4', 'txt', 'csv', 'webp', 'mov', 'm4v',]
  const suffix = fileType.toLowerCase()
  return fileSuffix.indexOf(suffix) >= 0
}


export function formatBytesMixed(bytes) {
  if (!bytes) { return 0 }
  const units = {
    TB: 1024 * 1024 * 1024 * 1024,
    GB: 1024 * 1024 * 1024,
    MB: 1024 * 1024,
    KB: 1024
  };
  let result = '';
  let remainingBytes = bytes;
  // 从最大的单位开始逐步转换  
  Object.keys(units).find(unit => {
    if (remainingBytes >= units[unit]) {
      const quantity = Math.round((remainingBytes / units[unit]) * 10) / 10;
      // remainingBytes -= quantity * units[unit];
      if (quantity > 0) {
        result += `${quantity}${unit} `;
        return true
      }
    }
  });
  // 如果还有剩余的字节，且不足以构成一个完整的MB，则显示为字节  
  if (!result) {
    result += `${remainingBytes}B`;
  }
  return result;
}

export const getCloudDiskFileTypeIdentification = Type => {
  let fileTypeIdentification;
  const fileType = Type ? Type.toLowerCase() : Type;
  switch (fileType) {
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'webp':
    case 'gif':
      fileTypeIdentification = cloudDiskFileTypeIdentification.image;
      break;
    case 'mp3':
    case 'm4a':
    case 'wav':
    case 'flac':
    case 'aac':
    case 'ogg':
    case 'aiff':
    case 'wma':
      fileTypeIdentification = cloudDiskFileTypeIdentification.audio;
      break;
    case 'mp4':
    case 'avi':
    case 'mpg':
    case 'wmv':
    case 'mov':
    case 'm4v':
    case 'mpeg':
      fileTypeIdentification = cloudDiskFileTypeIdentification.video;
      break;
    case 'doc':
    case 'docx':
    case 'dot':
    case 'dotx':
    case 'docm':
      fileTypeIdentification = cloudDiskFileTypeIdentification.word;
      break;
    case 'xlsx':
    case 'xls':
    case 'xlsm':
    case 'xlsb':
    case 'xlt':
    case 'xltx':
      fileTypeIdentification = cloudDiskFileTypeIdentification.excel;
      break;
    case 'txt':
      fileTypeIdentification = cloudDiskFileTypeIdentification.text;
      break;
    case 'ppt':
    case 'pptx':
    case 'pps':
    case 'ppsm':
      fileTypeIdentification = cloudDiskFileTypeIdentification.ppt;
      break;
    case 'zip':
    case 'rar':
    case '7z':
    case 'tar':
    case 'gz':
    case 'bz2':
    case 'dzip':
    case 'zipx':
      fileTypeIdentification = cloudDiskFileTypeIdentification.zip;
      break;
    case 'pdf':
    case 'pdfa':
      fileTypeIdentification = cloudDiskFileTypeIdentification.pdf;
      break;
    case 'skp':
    case 'skm':
    case 'suf':
      fileTypeIdentification = cloudDiskFileTypeIdentification.skp;
      break;
    case 'cad':
    case 'dwg':
    case 'dxf':
    case 'dws':
    case 'dwt':
    case 'ocf':
      fileTypeIdentification = cloudDiskFileTypeIdentification.cad;
      break;
    case '3dm':
    case '3dmax':
    case 'dmax':
    case '3ds':
    case 'max':
    case 'mat':
    case 'fbx':
    case 'obj':
    case 'dae':
    case 'ifc':
    case 'stl':
    case 'ply':
    case 'glb':
    case 'gltf':
    case 'vrmesh':
    case 'cgr':
    case 'abc':
      fileTypeIdentification = cloudDiskFileTypeIdentification.dmax;
      break;
    case 'ai':
    case 'eps':
    case 'ait':
      fileTypeIdentification = cloudDiskFileTypeIdentification.ai;
      break;
    case 'rvt':
    case 'rte':
    case 'rfa':
    case 'rst':
    case 'rft':
    case 'rvz':
      fileTypeIdentification = cloudDiskFileTypeIdentification.revit;
      break;
    default:
      fileTypeIdentification = cloudDiskFileTypeIdentification.unknow;
  }
  return fileTypeIdentification;
}

export const isGif = url => {
  if (typeof (url) !== 'string') { return false }
  const urlArr = url?.split('.')
  const suffix = urlArr && urlArr[urlArr?.length - 1]
  return suffix?.toLocaleLowerCase() === 'gif'
}

export const compressedMedia = (file, url, other = {}) => {
  // 将 URL 转换为小写（避免大小写问题）
  const lowerCaseUrl = url.toLowerCase();

  // 检查 URL 是否以 '.gif' 结尾
  const isGif = lowerCaseUrl.endsWith('.gif');
  if (isGif) {
    return
  }
  let data = {
    fileName: file.name,
    url,
    ...other
  }
  if (file.type.startsWith('image')) {
    const api = data?.sourceType ? uploadImgNewInQueue : uploadImgInQueue
    api(data)
  } else if (file.type.startsWith('video')) {
    uploadVideoInQueue(data)
  }
}

// 阿里对象存储 简单上传不支持获取上传进度 doc:https://www.alibabacloud.com/help/zh/oss/developer-reference/simple-upload-8?spm=a2c63.p38356.0.0.272d5c70qEScWx
export const uploadAliOss =  (file, isCompress = true, rename, path, other = {}) => {

  // 封装上传逻辑为函数，方便重试调用
  const upload = async () => {

    // 定义最大重试次数
    const MAX_RETRY = 1;
    let retryCount = 0;

    try {
      let filePath = await generateRandomFilePath(file, rename);
      if (path) {
        filePath = path;
      }
      const roleData = await getAssumeRoleByUser();
      const expireTime = new Date(roleData.result.expiration).getTime();
      const now = Date.now();
      const bufferTime = 30 * 60 * 1000; // 30分钟缓冲
      const refreshInterval = expireTime - now - bufferTime;
      const client = new OSS({
        region: aliOssConfigInfo.region,
        bucket: aliOssConfigInfo.bucket_name,
        endpoint: aliOssConfigInfo.end_point,
        accessKeyId: roleData?.result?.accessKeyId,
        accessKeySecret: roleData?.result?.accessKeySecret,
        cname: true,
        stsToken: roleData?.result?.securityToken,
        expiration: roleData?.result?.expiration,
        timeout: 120000,
        refreshSTSTokenInterval: refreshInterval > 0 ? refreshInterval : 5 * 60 * 1000, // 最小5分钟刷新,
        refreshSTSToken: async () => {
          const res = await getAssumeRoleByUser();
          const { accessKeyId, accessKeySecret, securityToken } = res.result || {}
          return {
            accessKeyId,
            accessKeySecret,
            stsToken: securityToken,
          };
        },
      });
      const result = await client.put(filePath, file);
      if (result.res.status === 200) {
        let url = decodeURIComponent(result.url);
        // 不压缩标识
        if (isCompress && other?.isCompress != false) {
          compressedMedia(file, url, other);
        }
        return {
          success: true,
          errorInfo: { status: result.res.status, name: 'success' },
          result: url,
          filePath
        };
      } else {
        return {
          success: false,
          errorInfo: { status: result.res.status, name: 'error' },
          result: null,
          filePath
        };
      }
    } catch (error) {
      console.log(error.code,'codecoede');
      
      // 判断是否为Token过期错误且未超过最大重试次数
      if (error.code === 'SecurityTokenExpired' && retryCount < MAX_RETRY) {
        retryCount++;
        console.log(`Token过期，开始第${retryCount}次重试...`);
        // 递归调用上传逻辑进行重试
        return upload();
      }
      // 其他错误或重试次数用尽，返回失败
      return {
        success: false,
        errorInfo: error,
        result: null,
        filePath: ''
      };
    }
  };

  return new Promise(async resolve => {
    const result = await upload();
    resolve(result);
  });
};

export const initOssClient = async () => {
  try {
    const roleData = await getAssumeRoleByUser();
    const { accessKeyId, accessKeySecret, securityToken } = roleData.result || {};
    if (!accessKeyId || !accessKeySecret || !securityToken) {
      throw new Error('STS凭证获取失败');
    }
    const expireTime = new Date(roleData.result.expiration).getTime();
    const now = Date.now();
    const bufferTime = 30 * 60 * 1000; // 30分钟缓冲
    const refreshInterval = expireTime - now - bufferTime;
    const client = new OSS({
      region: aliOssConfigInfo.region,
      accessKeyId: accessKeyId,
      accessKeySecret: accessKeySecret,
      stsToken: securityToken,
      expiration: roleData?.result?.expiration,
      // accessKeyId: bujueDecrypt(process.env.TEST_ALI_OSS_ACCESS_KEY),
      // accessKeySecret: bujueDecrypt(process.env.TEST_ALI_OSS_SECRET_KEY),
      bucket: aliOssConfigInfo.bucket_name,
      cname: true,
      endpoint: aliOssConfigInfo.end_point,
      refreshSTSTokenInterval: refreshInterval > 0 ? refreshInterval : 5 * 60 * 1000, // 最小5分钟刷新,
      refreshSTSToken: async () => {
        const res = await getAssumeRoleByUser();
        const { accessKeyId, accessKeySecret, securityToken } = res.result || {};
        return { accessKeyId, accessKeySecret, stsToken: securityToken };
      },
    })
    return client
  } catch (error) {
    console.log(error, 'errorerror');
  }
}

// 阿里OSS断点续传参数 doc:https://www.alibabacloud.com/help/zh/oss/developer-reference/resumable-upload-9?spm=a2c63.p38356.0.0.251e6220bm34UZ
// 文件小于1MB请调用（不觉项目） uploadAliOss
export const uploadAliOssBreakpointContinuationUpload = async (ossClient, file, filePath, progressCallback, resumeCallback, speedCallback, partSize = 1 * 1024 * 1024, parallel = 1) => {

  // 保存断点信息
  let checkpoint = null;

   // 封装上传逻辑（支持重试）
  const uploadWithRetry = async (newOssClient) => {

    // 最大重试次数
    const MAX_RETRY = 1;
    let retryCount = 0;

    try {
      const result = await newOssClient.multipartUpload(filePath, file, {
        partSize,
        parallel,
        // 传递断点信息，实现续传
        checkpoint,
        progress: (p, cpt, res) => {
          // 保存最新的断点信息
          checkpoint = cpt;
          if (progressCallback !== null) {
            progressCallback(p)
          }
          if (resumeCallback !== null) {
            resumeCallback(cpt)
          }
          if (res.size === 0 && speedCallback !== null) {
            speedCallback(partSize / (res.rt / 1000))
          }
        },
      })
      if (result.res.status === 200) {
        let url = aliOssConfigInfo.end_point + '/' + result.name
        return({
          success: true,
          errorInfo: { status: result.res.status, name: 'success' },
          result: url
        })
      } else {
        return({
          success: false,
          errorInfo: { status: result.res.status, name: 'error' },
          result: null
        })
      }
    } catch (error) {
      // 暂停报错
      // errorInfo: { status: 0, name: 'cancel' },
      // 捕获Token过期错误且未超过重试次数
      if (error.code === 'SecurityTokenExpired' && retryCount < MAX_RETRY) {
        retryCount++;
        console.log(`STS Token过期，开始第${retryCount}次重试...`);
        // 刷新Client并重新上传（复用断点信息）
        const newClient = await initOssClient();
        return uploadWithRetry(newClient);
      }
      return({
        success: false,
        errorInfo: error,
        result: null
      })
    }
  }
  return new Promise(async resolve => {
    const newOssClient = await ossClient;
    const result = await uploadWithRetry(newOssClient);
    resolve(result);
  })
}

// 阿里OSS断点续传继续上传
export const uploadAliOssBreakpointContinuationContinueUpload = (ossClient, file, filePath, abortCheckpoint, progressCallback, resumeCallback, speedCallback, partSize = 1 * 1024 * 1024, parallel = 1) => {
  
  // 保存断点信息
  let checkpoint = null;

  // 封装上传逻辑（支持重试）
  const uploadWithRetry = async newOssClient => {

    // 最大重试次数
    const MAX_RETRY = 1;
    let retryCount = 0;
    
    try {
      const result = await newOssClient.multipartUpload(filePath, file, {
        checkpoint: checkpoint || abortCheckpoint,
        partSize,
        parallel,
        progress: (p, cpt, res) => {
          // 保存最新的断点信息
          checkpoint = cpt;
           if (progressCallback !== null) {
            progressCallback(p)
          }
          if (resumeCallback !== null) {
            resumeCallback(cpt)
          }
          if (res.size === 0 && speedCallback !== null) {
            speedCallback(partSize / (res.rt / 1000))
          }
        },
      });
      if (result.res.status === 200) {
        let url = aliOssConfigInfo.end_point + '/' + result.name
        return({
          success: true,
          errorInfo: { status: result.res.status, name: 'success' },
          result: url
        })
      } else {
        return({
          success: false,
          errorInfo: { status: result.res.status, name: 'error' },
          result: null
        })
      }
    } catch (error) {
      // 捕获Token过期错误且未超过重试次数
      if (error.code === 'SecurityTokenExpired' && retryCount < MAX_RETRY) {
        retryCount++;
        console.log(`STS Token过期，开始第${retryCount}次重试...`);
        // 刷新Client并重新上传（复用断点信息）
        const newClient = await initOssClient();
        return uploadWithRetry(newClient);
      }
      return({
        success: false,
        errorInfo: error,
        result: null
      })
    }
  }

  return new Promise(async resolve => {
    const newOssClient = await ossClient;
    const result = await uploadWithRetry(newOssClient);
    resolve(result);
  })
}

export const isHwObsMedia = url => {
  const regex = /^https:\/\/(.*).obs.(.*).myhuaweicloud.com/i;
  return regex.test(url)
}

export const isAliOssMedia = url => {
  const regex = /^https:\/\/(.*).oss-(.*).aliyuncs.com|^https:\/\/oss-(.*).panzitech.com/i;
  return regex.test(url)
}


/**
 * 当图片是png的时候去掉模糊和背景
 * @param {*} url 图片的url地址 
 * @returns ture 或者false 
 */
export const isPngImage = (url) => {

  var regex = /\.(png)$/i;
  return regex.test(url)
}

//  通过 URLSearchParams 对象构建查询字符串 

export const toURLSearchParams = (url = '', params) => {
  const search_params = new URLSearchParams();
  Object.entries(params || {}).map(v => {
    search_params.append(v[0], v[1]);
  })
  return url + '?' + search_params.toString();
}

// 判断视频地址能否播放
export const canPlayVideo = url => {
  return new Promise(resolve => {
    const video = document.createElement('video');
    video.src = url;
    video.addEventListener('canplay', () => resolve(true))
    video.addEventListener('error', () => resolve(false))
    video.addEventListener('loadedmetadata', () => resolve(true))
  })
}

// 获取作品视频压缩地址
export const getWorksVideo = url => {
  let compressionVideoUrl
  compressionVideoUrl = url.split(aliOssConfigInfo.end_point).join(aliOssConfigInfo.videos_compression_end_point)
  let arr = compressionVideoUrl.split('.')
  arr[arr.length - 2] = arr[arr.length - 2] + '_1920x1080'
  compressionVideoUrl = arr.join('.')
  return compressionVideoUrl
}

export function getHtmlArray(params = "") {
  // 正则表达式匹配文本内容
  // const regex = /<[^>]*>([^<]+)<\/[^>]*>/g;
  let regExp = /<[^>]+>/g; // 匹配HTML标签
  // let matches = [];
  let match = params.replace(regExp, ''); // 移除HTML标签

  return [match]
  // console.log(matches);
}

export const cloudDiskUndercapacityTip = async (isAdmin, nextFun, toastTip = '容量不足', zIndex) => {
  const { t } = useTranslation()
  let _isAdmin = isAdmin
  let clientType, clientId
  if (_isAdmin === null) {
    clientType = getQueryVariable('clientType') * 1 || 1
    clientId = getQueryVariable('clientId')
    let res = await queryByTeamIdAndUserId(clientId, currentUser().id)
    if (res.data.success) {
      _isAdmin = res.data.result.role === 2
    }
  }
  if (_isAdmin || clientType === 1) {
    const title = t('容量不足');
    const content = t('尊敬的用户，您的不觉云存储空间不足，为避免影响正常使用，建议您尽快进行容量升级。');
    const okText = t('去扩容');
    Modal.confirm({
      className: 'works-confirm-model',
      wrapClassName: 'works-confirm-model-wrap',
      ...(zIndex ? { zIndex } : {}),
      title,
      content,
      okText,
      cancelText: null,
      closable: true,
      onOk: () => {
        nextFun()
      },
      onCancel: null,
      cancelButtonProps: {
        style: {
          display: 'none'
        }
      }
    })
  } else {
    message.error(t(toastTip))
  }
}

export const goTeamCloud = clientId => {
  window.location.href = `/team_cloud.html/#/cloud?clientId=${encodeURIComponent(clientId)}&selectTab=9`
}

// 目前用于锚点气泡
export const textTruncateString = (str, maxLength = 14) => {
  let length = 0;
  let result = '';

  for (let i = 0; i < str.length; i++) {
    const char = str[i];
    if (/[\u4e00-\u9fa5]/.test(char)) {
      length += 2;
    } else {
      length += 1;
    }

    if (length > maxLength) {
      result += '...';
      break;
    }

    result += char;
  }

  return result;
}

export const getWorksLock = (opacity, secretArray) => {
  let _lockIcon = 'icon-suo-baise'
  let _secretArray = secretArray ?? roleValueList

  if (opacity) {
    _lockIcon = _secretArray.indexOf(0) !== -1?'icon-suo-heise': _secretArray.indexOf(1) !== -1 ? 'icon-suoC-changtaise' : (_secretArray.indexOf(3) !== -1 ? 'icon-suoB-changtaise' : (_secretArray.indexOf(2) !== -1 ? 'icon-suoA-changtaise' : 'icon-suo-heise'))

  } else {
    _lockIcon = _secretArray.indexOf(0) !== -1?'icon-suo-baise': _secretArray.indexOf(1) !== -1 ? 'icon-suoC-baise' : (_secretArray.indexOf(3) !== -1 ? 'icon-suoB-baise' : (_secretArray.indexOf(2) !== -1 ? 'icon-suoA-baise' : 'icon-suo-baise'))
  }

  return _lockIcon
}

export const containsChinese = (str) => {
  return /[\u4e00-\u9fff]/.test(str);
}

// 获取文件后缀
export const getFileFormat = (url) => {
  if (!url) return '';
  const arr = url.split('.');
  // 转小写
  if (arr.length) return '.' + arr[arr.length - 1]?.toLocaleLowerCase();
  return ''
}

//上传图片背景是否为纯色
export const handleBgIsWhite = async (isVideo, url) => {
  let data = {
    checkUrl: url,// 资材首图
  }
  if (isVideo) {
    const base64ImgSrc = await videoFrameImg(url);
    data = {
      checkUrl: base64ImgSrc?.[0] // 视频第一帧图片
    }
  }
  const { result, success } = await detectImageBase(data);
  if (success) {
    return result
  }
  return {};
}

export const imageSpecialUploadType = () => {
  return ['.heic', '.heif', '.tif', '.tiff', '.tiff64']
}

export const isSpecialImageTypeFromUrl = url => {
  const arr = url.split('.')
  const suffix = arr[arr.length - 1]
  return imageSpecialUploadType().indexOf(suffix?.toLocaleLowerCase()) >= 0
}

export const isSpecialImageTypeFromImageType = suffix => {
  return imageSpecialUploadType().indexOf('.' + suffix?.toLocaleLowerCase()) >= 0
}

export const worksDisplayUploadType = () => {
  return ['.png', '.jpg', '.jpeg', '.webp', '.gif', '.mp4', ...imageSpecialUploadType()]
}

export const worksCertificateUploadType = () => {
  return ['.png', '.jpg', '.jpeg', '.webp', ...imageSpecialUploadType()]
}

export const getAntdSelectFileType = fileType => {
  const arr = fileType.split('/')
  return arr[arr.length - 1]
}

// 获取主域名
export const getUrlMainDomain = url => {
  const parsedUrl = new URL(url)
  const hostname = parsedUrl.hostname
  const mainDomain = hostname.split('.').slice(-2).join('.')
  return mainDomain
}

// 函数：预估文字宽度
export const estimateTextWidth = (text, fontSize = '12px', fontFamily = 'SourceHanSansCN-Regular') => {
  // 创建一个临时的DOM元素（通常是span或div）
  const tempElement = document.createElement('span');
  // 设置字体大小和字体家族
  tempElement.style.fontSize = fontSize;
  tempElement.style.fontFamily = fontFamily;
  // 设置为不可见，避免影响页面布局
  tempElement.style.visibility = 'hidden';
  tempElement.style.position = 'absolute';
  tempElement.style.whiteSpace = 'nowrap'; // 防止换行
  // 将文本内容设置到临时元素中
  tempElement.innerText = text;
  // 将临时元素添加到DOM中（必须添加到DOM中才能正确计算宽度）
  document.body.appendChild(tempElement);
  // 获取宽度
  const width = tempElement.offsetWidth;
  // 从DOM中移除临时元素
  document.body.removeChild(tempElement);
  return width;
}
// 获取图片宽高
export const getPxByPath = (url) => {
  let width, height;
  const filePath = url.split('byte_')[1]
  const strs = filePath ? filePath.split("_") : [''];
  if (strs[0].indexOf("x") >= 0) {
    const px = strs[0].split("x");
    width = px[0];
    height = px[1];
  }
  return { width, height };
};
// 获取图片name
export const getFileName = (url) => {
  if(!url) return ''
  // const filePath = url.split('byte_')[1]
  // let strs = filePath ? filePath.split("_") : [''];
  // if (strs.length>1) {
  //   strs.shift()
  //   return strs.join('_');
  // }
  const arr = url.split('/')
  return arr[arr.length-1];
};

// 获取700的压缩图
export const getZipImg700 = (item, isBefore = false) => { //isBefore:是否去原先的压缩图zip-
  if (!item?.url) return item?.url || '';
  // 不存在取原先的压缩图，用于兼容资材封面
  if (isBefore && !(item?.url700 || item?.url2000)) {
    return toQualityImg(item.url, true)
  }
  return item?.url700 || item?.url2000 || item.url;
};
// 获取300的压缩图
export const getZipImg300 = (item) => {
  if (!item?.url) return item?.url || '';
  return item?.url300 || item?.url700 || item?.url2000 || item.url;
};
// 从云盘文件记录(秒传/MD5命中返回的 cloudFile)中提取压缩图字段，
// 用于「上传已存在的图片」时回填压缩图(url300/url700/url2000/宽高)，避免保存后丢失压缩图。
export const pickCloudImgZipFields = (cloudFile) => {
  const entity = cloudFile?.imageEntity || {};
  return {
    url300: entity.url300 || '',
    url700: entity.url700 || '',
    url2000: entity.url2000 || '',
    width: entity.width,
    height: entity.height,
  };
};
// 获取2000的压缩图
export const getZipImg2000 = (item, isBefore = false) => {
  if (!item?.url) return item?.url || '';
  // 不存在取原先的压缩图，用于兼容资材封面
  if (isBefore && !item?.url2000) {
    return toQualityImg(item.url, true)
  }
  return item?.url2000 || item.url;
};

export const getTietuImgs = (designStyles) => {
  let arr = [];
  if (!designStyles?.length) return [];
  designStyles.forEach((group) => {
    if (group?.relateTextureGroups?.length) {
      group.relateTextureGroups.forEach((img) => {
        if (img?.images?.length) arr.push(...img?.images);
      });
    }
  });
  return arr;
};

/**
   * 通过getBoundingClientRect属性判断元素是否在可视区域
   * @param element
   * @returns
   */
export const isInViewPort = (element) => {
  const viewWidth = window.innerWidth || document.documentElement.clientWidth;
  const viewHeight =
    window.innerHeight || document.documentElement.clientHeight;
  const { top, right, bottom, left } = element.getBoundingClientRect();
  return top >= 0 && left >= 0 && right <= viewWidth && bottom <= viewHeight;
};

// 资材校验图片宽高
// 文档地址（图片尺寸限制和建议） https://panzi.yuque.com/uy8qsa/bfp54t/ftv3ga8nacn66ggk
export const verifyImageSizeWH = async (file, fileList, minimumSize = 30000, suggestedSize = 30000, returnError = false) => {
  handleVerifyImageSizeWHToast(fileList, minimumSize, suggestedSize)
  try {
    const imgTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
    const isImage = imgTypes.indexOf(file.type) >= 0;
    if (!isImage) {
      return true
    }
    const dataUrl = await new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = (event) => resolve(event.target.result)
      reader.onerror = (error) => reject(error)
      reader.readAsDataURL(file)
    })
    const image = await new Promise((resolve, reject) => {
      const img = new Image()
      img.onload = () => resolve(img)
      img.onerror = (error) => reject(error)
      img.src = dataUrl
    })
    if (image.width < suggestedSize && image.height < suggestedSize) {
      if (image.width < minimumSize && image.height < minimumSize) {
        return returnError;
      } else {
        return true
      }
    }
    return true
  } catch (error) {
    return returnError
  }
}

export const handleVerifyImageSizeWHToast = async (fileList, minimumSize, suggestedSize) => {
  if (!window.verifyImageFileList) {
    window.verifyImageFileList = fileList
    let isToastInfo
    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i];
      let fileInfo = await verifyImageSizeWHToastText(file, fileList, minimumSize, suggestedSize)
      if (fileInfo?.allowType !== 2) {
        if (isToastInfo == null || fileInfo.allowType != 1) {
          isToastInfo = fileInfo
        }
      }
    }
    if (isToastInfo != null && isToastInfo?.toastText?.length !== 0) {
      if (isToastInfo?.allowType === 1) {
        message.warn(isToastInfo?.toastText)
      } else if (isToastInfo?.allowType === 0) {
        message.error(isToastInfo?.toastText)
      }
    }
    window.verifyImageFileList = null
  }
}

// allowType 0 不允许上传 低于最小尺寸 1允许上传 低于建议尺寸 2允许上传 符合尺寸
export const verifyImageSizeWHToastText = async (file, fileList, minimumSize, suggestedSize) => {
  try {
    const dataUrl = await new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = (event) => resolve(event.target.result)
      reader.onerror = (error) => reject(error)
      reader.readAsDataURL(file)
    })
    const image = await new Promise((resolve, reject) => {
      const img = new Image()
      img.onload = () => resolve(img)
      img.onerror = (error) => reject(error)
      img.src = dataUrl
    })
    const curlang = sessionStorage.getItem('lang')||window.lang
    if (image.width < suggestedSize && image.height < suggestedSize) {
      if (image.width < minimumSize && image.height < minimumSize) {
        const str = curlang==='en-US,en'?`To ensure the display effect, the length of the image should not be less than ${minimumSize}. It is recommended to upload images with a size of ${suggestedSize} * ${suggestedSize} or more`:`为保证展示效果，图片长边尺寸不得低于${minimumSize}，建议上传${suggestedSize}*${suggestedSize}以上的图片`
        return {
          file,
          allowType: 0,
          toastText: str
        }
      } else {
        const str = curlang==='en-US,en'?`Suggest uploading images of ${suggestedSize} * ${suggestedSize} or above for better display effect`:`建议上传${suggestedSize}*${suggestedSize}以上的图片，以获得更好的展示效果`
        return {
          file,
          allowType: 1,
          toastText: str
        }
      }
    }
    return {
      file,
      allowType: 2,
      toastText: ''
    }
  } catch (error) {
    return {
      file,
      allowType: 0,
      toastText: ''
    }
  }
}

export const isWorksFixedField = field => {
  return field === 'tmDesign' || field === 'style' || field === 'category'
}

export const getWorksCustomGroupFieldValue = (customGroupField, worksDetail, timeFormat) => {
  let customGroupFieldValue = ''
  switch (customGroupField?.mappingFieldName) {
    case 'tmDesign':
      customGroupFieldValue = moment(worksDetail?.tmDesign).format(timeFormat)
      break;
    case 'style':
      customGroupFieldValue = worksDetail?.style
      break;
    case 'category':
      customGroupFieldValue = worksDetail?.category
      break;
    default:
      customGroupFieldValue = customGroupField?.value ?? ''
  }
  return customGroupFieldValue
}

export const handleWorksCustomFieldListDuplicateName = (customGroupFieldList, customField) => {
  let _customField = customField
  for (let i = 0; i < customGroupFieldList.length; i++) {
    if (customGroupFieldList[i].name === customField) {
      _customField = customField + '(1)'
      break
    }
  }
  return _customField
}

// 展开/全屏
export const requestFullScreen = (element) => {
  var requestMethod =
    element.requestFullscreen ||
    element.webkitRequestFullscreen ||
    element.msRequestFullscreen ||
    element.mozRequestFullScreen;
  if (requestMethod) {
    requestMethod.call(element);
  }
}

// 退出/全屏
export const exitFullScreen = () => {
  let isFull =
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.msFullscreenElement ||
    document.mozFullScreenElement;
  if (isFull) {
    var exitMethod =
      document.exitFullscreen ||
      document.webkitExitFullscreen ||
      document.msExitFullscreen ||
      document.mozCancelFullScreen;
    if (exitMethod) {
      exitMethod.call(document);
    }
  } else {
    message.info('退出失败，请使用F11退出全屏')
  }
}

// 判断是否全屏
export const isFullscreenElement = () => {
  let isFull =
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.msFullscreenElement ||
    document.mozFullScreenElement;
  const windowHeight = window.innerHeight;
  const screenHeight = screen.height;
  const threshold = 1;
  if (Math.abs(windowHeight - screenHeight) <= threshold) {
    isFull = true
  }
  return !!isFull;
}

// 切换全屏
export const changeFullScreen = (element=document.body) => {
   const isFull = isFullscreenElement();
    if (isFull) {
      exitFullScreen();
    } else {
      requestFullScreen(element);
    }
}

// 通过 URL 对象和 pathname 提取扩展名
export const getFileTypeFromUrl = (url) => {
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    // 获取最后一个点之后的部分作为扩展名
    const extension = pathname.split('.').pop().toLowerCase();
    return extension || null;
  } catch (e) {
    console.error('Invalid URL:', e);
    return null;
  }
}

export const getMlKey = (key) => {
  return 'ml' + key.charAt(0).toUpperCase() + key.slice(1);
}
export const mlKeytokey = (mlkey) => {
  let key = mlkey.replace('ml', '')
  return key.charAt(0).toLowerCase() + key.slice(1);
}


// 密码验证规则函数
export const validatePassword = (_, value) => {
  const { t } = useTranslation();
  
  if (!value) {
    return Promise.resolve();
  }

  // 长度校验：6～16位
  if (value.length < 6 || value.length > 16) {
    return Promise.reject(new Error(t('确保密码长度是 6-16 位')));
  }

  // 纯数字校验：不允许纯数字
  if (/^\d+$/.test(value)) {
    return Promise.reject(new Error(t('密码不允许纯数字')));
  }

  // 字符类型校验：只能是数字、字母和指定特殊符号
  if (!/^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{}|;':",./?]+$/.test(value)) {
    return Promise.reject(new Error(t('只能输入数字、英文字母和符号')));
  }

  // 检查连续相同字符（3个）
  const sameCharRegex = /(.)\1\1\1/;
  if (sameCharRegex.test(value)) {
    return Promise.reject(new Error(t('密码中不能出现 3 位以上连续字符（如aaaa,1234）')));
  }

  // 检查连续递增或递减序列（4个）
  for (let i = 0; i <= value.length - 4; i++) {
    const char1 = value.charCodeAt(i);
    const char2 = value.charCodeAt(i + 1);
    const char3 = value.charCodeAt(i + 2);
    const char4 = value.charCodeAt(i + 3);

    // 检查是否是连续递增（如abcd, 1234）
    if (char2 === char1 + 1 && char3 === char2 + 1 && char4 === char3 + 1) {
      return Promise.reject(new Error(t('密码中不能出现 3 位以上连续字符（如aaaa,1234）')));
    }

    // 检查是否是连续递减（如dcba, 4321）
    if (char2 === char1 - 1 && char3 === char2 - 1 && char4 === char3 - 1) {
      return Promise.reject(new Error(t('密码中不能出现 3 位以上连续字符（如aaaa,1234）')));
    }
  }

  return Promise.resolve();
};

// 使用Crypto-JS实现文件流的SHA-256哈希计算
const CHUNK_SIZE = 2 * 1024 * 1024; // 2MB 分片，避免大文件内存溢出

const readChunk = (file, offset, size) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(new Uint8Array(e.target.result));
    reader.onerror = reject;
    reader.readAsArrayBuffer(file.slice(offset, offset + size));
  });

const arrayBufferToWordArray = (ab) => {
  const u8 = new Uint8Array(ab);
  return CryptoJs.lib.WordArray.create(u8, u8.length);
};

const fileSHA256 = async (file) => {
  const sha256 = CryptoJs.algo.SHA256.create();
  let offset = 0;
  while (offset < file.size) {
    const chunk = await readChunk(file, offset, Math.min(CHUNK_SIZE, file.size - offset));
    sha256.update(arrayBufferToWordArray(chunk));
    offset += chunk.length;
  }
  return sha256.finalize().toString();
};

export {
  getkey, getCookie,  getQueryVariable, isIPad,  identifyDevicePlatform, isWeChat, getOperatingSystem, isVideo, replaceUrlPort, useCdn, useCdnNew, isHadByTime,
  getZipImg,  isHadSize,  imgIsEnableYs, toQualityImg, fileSHA256
}
